import angular from "angular";
import { canApproveForm } from "./onboarding-action-policy.service";
import { configureStates, resolveFromParam } from "../../core/router/router-helper.provider";
import { Ng1StateDeclaration, Transition } from "angular-ui-router";
import { EmployeeService, StateProvinceService, IcdOfficeService, SiteModuleEnum, IcdCorporationService } from "../../core/services";
import { OnboardingDocumentService } from "../../core/services/data-services/onboarding-document.service";
import { ApexOwnerModal } from "./owner-modal/owner-modal.component";
import { UserProfileModal } from "./user-profile/user-profile.component";
import { FederalW4Modal } from "./federal-w4/federal-w4.component";
import { ALW4Modal } from "./al/al-w4.component";
import { ARW4Modal } from "./ar/ar-w4.component";
import { AZW4Modal } from "./az/az-w4.component";
import { KYW4Modal } from "./ky/ky-w4.component";
import { GAW4Modal } from "./ga/ga-w4.component";
import { MDW4Modal } from "./md/md-w4.component";
import { IMPLEMENTED_PROVINCE_STATE_IDS } from "./implemented-states";
import { NYW4Modal } from "./ny/ny-w4.component";
import { I9Modal } from "./i9/i9.component";
import { DDModal } from "./direct-deposit/direct-deposit.component";
import { ConfirmationModal } from "./confirmation-form/confirmation-form.component";
import { InfoModal } from "./info-modal/info-modal.component";
import { CAW4Modal } from "./ca/ca-w4.component";
import { W9Modal } from "./w9/w9.component";
import { PendingEmployeeModal } from "../roster/roster-table/pending-employee-modal.component";
import { PermissionGrantService } from "../../core/services/data-services/permission-grant.service";
import { CommentsModal } from "./comments/onboarding-comments";
import { CTW4Modal } from "./ct/ct-w4.component";
import { OnboardingTerminationModal } from "./termination-modal/termination-modal.component";
import moment from "moment";
import { OwnerPreviewSignatureModal } from "./preview-signature-modal/owner-preview-signature-modal.component";
import { FormChoiceModal } from "./form-choice-modal/form-choice-modal.component";
import { BoilerPlateW4Modal } from "./boilerplate/boiler-plate.component";
import { VAW4Modal } from "./va/va-w4.component";
import { ILW4Modal } from "./il/il-w4.component";
import { OHW4Modal } from "./oh/oh-w4.component";
import { NCW4Modal } from "./nc/nc-w4.component";
import { NJW4Modal } from "./nj/nj-w4.component";

const states: { state: string, config: Ng1StateDeclaration }[] = [{
    state: "application-status",
    config: {
        url: "/application-status",
        component: "apexDocumentEmpPortal",
        data: {
            pageHeader: "Roster",
            permissionKey: "navigation:applicationStatus"
        },
        resolve: {
            employee: (employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveIdentity();
            },
            userRole: (employee, onboardingDocumentService: OnboardingDocumentService) => {
                'ngInject';
                return onboardingDocumentService.getUserRole(employee.UserName)
            },
            employeeBankInfo: (employee, employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveEmployeeBankInfo(employee.EmployeeID); //.then((data) => { return data });
            },
            identity: (employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveIdentity();
            },
            permissionGrants: (permissionGrantService: PermissionGrantService) => {
                'ngInject';
                return permissionGrantService.retrievePermissionGrants({});
            },
            onboardingAccess: (employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrievePermissions({
                    stateName: "application-status"
                });
            },
            modalTitle: () => 'Modal Title',
            icdOffices: (icdOfficeService: IcdOfficeService) => {
                'ngInject';
                const ROSTER_MODULE = SiteModuleEnum.Roster;
                return icdOfficeService.retrieveIcdOffices({ moduleID: ROSTER_MODULE }) // Filter by roster module admin.
                    .then(function (icdOffices) {
                        icdOffices.sort(function (a, b) {
                            // Show offices where the user has create and read access first.
                            if (a.CanUpdate && !b.CanUpdate) {
                                return -1;
                            } else if (!a.CanUpdate && b.CanUpdate) {
                                return 1;
                            }
                            if (a.CanCreate && !b.CanCreate) {
                                return -1;
                            } else if (!a.CanCreate && b.CanCreate) {
                                return 1;
                            }

                            const nameA = a.OfficeName.toLowerCase();
                            const nameB = b.OfficeName.toLowerCase();
                            if (nameA < nameB) {//sort string ascending
                                return -1;
                            }
                            if (nameA > nameB) {
                                return 1;
                            }
                            return 0; //default return value (no sorting)
                        });
                        return icdOffices;
                    });
            },
            stateProvinces: (stateProvinceService: StateProvinceService) => {
                'ngInject';
                return stateProvinceService.retrieveStateProvinces();
            },
        }
    }
}, {
    state: "application-status.comments",
    config: {
        params: {
            appId: { value: null },
            userName: { value: null }
        },
        data: {
            pageHeader: "Roster",
            permissionKey: "navigation:applicationStatus"
        },
        resolve: {
            appId: ($transition$) => {
                'ngInject'
                return $transition$.params().appId;
            },
            userName: ($transition$) => {
                'ngInject'
                return $transition$.params().userName;
            },
            allComments: (onboardingDocumentService: OnboardingDocumentService, $transition$: Transition) => {
                'ngInject';
                const params = $transition$.params();
                return onboardingDocumentService.retrieveComments(params.appId);
            }
        },
        onEnter: ['$uibModal', '$state', 'appId', 'userName', 'allComments', '$transition$',
            function ($uibModal, $state, appId, userName, allComments, $transition$) {
                let source = 'application-status';
                $transition$.onSuccess({}, function (transition) {
                    source = transition.from().name
                    console.log("Successful Transition from " + transition.from().name + " to " + transition.to().name);
                });
                $uibModal.open({
                    ...CommentsModal,
                    resolve: {
                        appId: () => {
                            return appId;
                        },
                        allComments: () => {
                            return allComments;
                        },
                        userName: () => {
                            return userName
                        }
                    }
                }).result.then(function (result) {
                    console.log("Modal closed with result", result);
                }).catch(function (reason) {
                    console.log("Modal dismissed with reason", reason);
                }).finally(() => {
                    if (source === 'root') {
                        $state.transitionTo('root', null, { reload: true });
                    } else {
                        $state.transitionTo('application-status', null, { reload: true });
                    }
                });
            }]
    }
}, {
    state: "application-status.termination",
    config: {
        url: "/termination/:appId",
        component: "apexOnboardingTerminationModal",
        params: {
            appId: { value: null },
        },
        data: {
            pageHeader: "Terminate Employee",
            permissionKey: "navigation:applicationStatus"
        },
        resolve: {
            applicationId: ($transition$) => {
                'ngInject'
                return $transition$.params().appId;
            },
            application: (applicationId, onboardingDocumentService: OnboardingDocumentService) => {
                'ngInject';
                // Use methods from onboardingDocumentService here
                return onboardingDocumentService.retrieveApplicationById(applicationId);
            },
            employmentStatuses: employeeService => {
                'ngInject';
                return employeeService.retrieveEmployeeStatuses();
            },
            terminationReasons: employeeService => {
                'ngInject';
                return employeeService.retrieveTerminationReasons();
            },
            employee: (application, employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveEmployeeIdentity(application.EmployeeId);
            },
            employeeProfile: (application, employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveOnboardingEmployee(application.EmployeeId);
            },
        },
        onEnter: ['$uibModal', '$state', 'application', 'employmentStatuses', 'terminationReasons', 'employee', 'employeeProfile', '$transition$',
            function ($uibModal, $state, application, employmentStatuses, terminationReasons, employee, employeeProfile, $transition$) {
                let source = 'application-status';
                $transition$.onSuccess({}, function (transition) {
                    source = transition.from().name
                    console.log("Successful Transition from " + transition.from().name + " to " + transition.to().name);
                });
                const modalInstance = $uibModal.open({
                    ...OnboardingTerminationModal,
                    resolve: {
                        application: () => {
                            return application;
                        },
                        employee: () => {
                            return employee
                        },
                        employeeProfile: () => {
                            return employeeProfile;
                        },
                        employmentStatuses: () => {
                            return employmentStatuses;
                        },
                        terminationReasons: () => {
                            return terminationReasons;
                        }
                    }
                });

                modalInstance.result.then((result) => {
                    console.log("Modal closed with result", result);
                }).catch((reason) => {
                    alert("An error occured terminating the employee:" + reason);
                    console.log("Modal dismissed with reason", reason);
                }).finally(() => {
                    if (source === 'root') {
                        $state.transitionTo('root', null, { reload: true });
                    } else {
                        $state.transitionTo('application-status', null, { reload: true });
                    }
                });
            }]
    }
}, {
    state: "application-status.pendingModal",
    config: {
        //url:"/onboard2/:employeeId/:icdOfficeID/:rehire",
        params: {
            employeeId: { type: "string", value: null },
            icdOfficeID: { type: "int", value: null },
            rehire: { type: 'bool', value: false },
            onboard: { type: 'bool', value: false }
        },
        resolve: {
            icdOfficeId: resolveFromParam("icdOfficeID"),
            employeeId: resolveFromParam("employeeId"),
            rehire: resolveFromParam("rehire"),
            onboard: resolveFromParam("onboard"),
            isNew: (employeeId) => {
                'ngInject';
                return employeeId == null;
            },
            employeeData: (employeeService: EmployeeService, $transition$: Transition, isNew) => {
                'ngInject';
                if (isNew) {
                    return null;
                }
                const params = $transition$.params();
                return employeeService.retrieveEmployee(params.employeeId);
            },
            translations: localeService => {
                'ngInject';
                return localeService.retrieveCurrentLocaleTranslations();
            },
            assignableRoles: (employeeService, translations) => {
                'ngInject';
                return employeeService.retrieveEmployeeAssignableRoles().then(roles => {
                    for (const role of roles) {
                        if (role.Description && role.Description[0] === "|") {
                            role.Description = translations[role.Description.slice(1)]
                        }
                    }
                    return roles;
                });
            },
            employee: (employeeData, assignableRoles, isNew) => {
                'ngInject';
                if (isNew) {
                    return null;
                }
                employeeData.GlobalRoles = assignableRoles
                    .map(function (role) {
                        return {
                            RoleID: role.Id,
                            Name: role.Name,
                            Description: role.Description,
                            IsInRole: !!employeeData.GlobalRoles[role.Id],
                            AdministeredModules: role.AdministeredModules
                        };
                    });
                return employeeData;
            },
            icdCorporation: (isNew, employeeId, identity, icdCorporationService: IcdCorporationService) => {
                'ngInject';
                if (!(employeeId != null && !isNew)) {
                    return icdCorporationService.retrieveIcdCorporation(identity.IcdCorporationID);
                } else {
                    return icdCorporationService.retrieveIcdCorporationByEmployee(employeeId);
                }
            },
            userProfile: (employeeService: EmployeeService, $transition$: Transition, isNew) => {
                'ngInject'
                if (isNew) {
                    return null;
                }
                const params = $transition$.params();
                return employeeService.retrieveEmployeeProfile(params.employeeId);
            },
            stateProvinces: (stateProvinceService: StateProvinceService) => {
                'ngInject';
                return stateProvinceService.retrieveStateProvinces();
            },
            employeeBankInfo: (employeeService: EmployeeService, $transition$: Transition, isNew) => {
                'ngInject';
                if (isNew) {
                    return null;
                }
                const params = $transition$.params();
                return employeeService.retrieveEmployeeBankInfo(params.employeeId);
            },
            telemapperLinked: (employeeService: EmployeeService, $transition$: Transition, isNew) => {
                'ngInject'
                return employeeService.checkForTelemapperLink();
            },
            onboardingApplication: (isNew, employee, onboardingDocumentService: OnboardingDocumentService) => {
                'ngInject';
                if (!isNew) {
                    return onboardingDocumentService.retrieveApplication(employee.UserName);
                } else {
                    return [];
                }
            },
            addlInputs: (isNew, onboardingDocumentService, employeeId) => {
                'ngInject';
                if (isNew) {
                    return null;
                }
                return onboardingDocumentService.retrieveAddlInputs(employeeId);
            },
            changeFormMapping: (onboardingDocumentService) => {
                'ngInject';
                return onboardingDocumentService.retrieveChangeFormMapping();
            }
        },
        onEnter: ['$uibModal', '$state', '$transition$', 'employee', 'userProfile', 'stateProvinces', 'employeeBankInfo', 'telemapperLinked', 'assignableRoles', '$transitions', 'onboardingApplication', 'identity', 'icdCorporation', 'addlInputs', 'rehire', 'onboard', 'changeFormMapping',
            function ($uibModal, $state, $transition$, employee, userProfile, stateProvinces, employeeBankInfo, telemapperLinked, assignableRoles, $transitions, onboardingApplication, identity, icdCorporation, addlInputs, rehire, onboard, changeFormMapping) {
                const params = $transition$.params();
                let source = 'application-status';
                $transitions.onSuccess({}, function (transition) {
                    source = transition.from().name
                    console.log(
                        "Successful Transition from " + transition.from().name +
                        " to " + transition.to().name
                    );
                });
                $uibModal.open({
                    ...PendingEmployeeModal,
                    resolve: {
                        employeeId: () => params.employeeId,
                        icdOfficeId: () => params.icdOfficeId,
                        rehire: () => params.rehire,
                        onboard: () => params.onboard,
                        employee: () => employee,
                        userProfile: () => userProfile,
                        stateProvinces: () => stateProvinces,
                        employeeBankInfo: () => employeeBankInfo,
                        isNew: () => params.employeeId == null,
                        telemapperLinked: () => telemapperLinked,
                        onboardingApplication: () => onboardingApplication,
                        identity: () => identity,
                        icdCorporation: () => icdCorporation,
                        addlInputs: () => addlInputs,
                        changeFormMapping: () => changeFormMapping
                    },
                }).result.then(function (result) {
                    console.log("Modal closed with result", result);
                }).catch(function (reason) {
                    console.log("Modal dismissed with reason", reason);
                }).finally(() => {
                    if (source === 'root') {
                        $state.transitionTo('root', null, { reload: true });
                    } else {
                        $state.transitionTo('application-status', null, { reload: true });
                    }
                });
            }],
        controller: ['$scope', '$state', 'redirectState', 'modalInstance', function ($scope, $state, redirectState, modalInstance) {
            // Use the selectedChild parameter to navigate to the chosen child state
            $scope.$on('modal.closing', function (event, reason, closed) {
                alert('closing');
            });

        }]
    }

}, {
    state: "application-status.info-modal",
    config: {
        component: "apexInfoModal",
        params: {
            notification: { value: null },
            state: { value: null },
            params: { value: null }
        },
        data: {
            pageHeader: "Application Status",
            permissionKey: "navigation:applicationStatus"
        },
        resolve: {
            notification: () => ['$stateParams', function ($stateParams) {
                return $stateParams.notification;
            }],
            state: () => ['$stateParams', function ($stateParams) {
                return $stateParams.state;
            }],
            params: () => ['$stateParams', function ($stateParams) {
                return $stateParams.params;
            }]
        },
        onEnter: ['notification', 'state', 'params', '$uibModal', '$transitions', function (notification, state, params, $uibModal, $transitions) {
            'ngInject';
            let source = 'application-status';
            $transitions.onSuccess({}, function (transition) {
                source = transition.from().name
                console.log("Successful Transition from " + transition.from().name + " to " + transition.to().name);
                if (transition.to().name === 'application-status.info-modal') {
                    $uibModal.open({
                        ...InfoModal,
                        resolve: {
                            notification: () => {
                                return "Your form is not completed yet. Do you want to leave?"
                            },
                            state: () => {
                                return "application-status";
                            },
                            params: () => {
                                return params
                            },
                            source: () => {
                                return source
                            }
                        },
                        size: 'sm',
                        backdrop: 'static'
                    }).result.then(function (result) {
                        console.log("Modal closed with result", result);
                    }).catch(function (reason) {
                        console.log("Modal dismissed with reason", reason);
                    });
                }
            });
        }]
    }
}, {
    state: "application-status.profile",
    config: {
        url: "/profile",
        component: "apexUserProfileModal",
        data: {
            pageHeader: "User Profile",
            permissionKey: "navigation:applicationStatus"
        },
        params: {
            applicationId: { value: null }
        },
        resolve: {
            ownerView: () => {
                return false;
            },
            //applicationId: ['$stateParams', function ($stateParams) {
            //    return $stateParams.applicationId;
            //}],
            employee: (employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveIdentity();
            },
            employeeId: (employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveIdentity().then(function (emp) {
                    return emp.EmployeeID;
                });
            },
            employeeProfile: (employeeId, employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveOnboardingEmployee(employeeId);
            },
            profile: (employeeId, employeeService: EmployeeService) => {
                'ngInject'
                return employeeService.retrieveEmployeeProfile(employeeId);
            },
            employeeBankInfo: (employeeId, employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveEmployeeBankInfo(employeeId); //.then((data) => { return data });
            },
            provinces: (stateProvinceService: StateProvinceService) => {
                'ngInject';
                return stateProvinceService.retrieveStateProvinces();
            },
            application: (employee, onboardingDocumentService: OnboardingDocumentService) => {
                'ngInject';
                // Use methods from onboardingDocumentService here
                return onboardingDocumentService.reterieveApplication(employee.EmployeeID);
            },
            genderOptions: (employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveGenders();
            },
            addlInputs: (onboardingDocumentService, employee) => {
                'ngInject';
                return onboardingDocumentService.retrieveAddlInputs(employee.EmployeeID);
            },
            maritalStatusOptions: (employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveMaritalStatuses();
            },
            changeFormMapping: (onboardingDocumentService) => {
                'ngInject';
                return onboardingDocumentService.retrieveChangeFormMapping();
            }
        },
        onEnter: ['$uibModal', '$state', '$transitions', 'ownerView', 'employee', 'employeeProfile', 'profile', 'employeeBankInfo', 'provinces', 'application', 'genderOptions', 'addlInputs', 'maritalStatusOptions', 'changeFormMapping', function ($uibModal, $state, $transitions, ownerView, employee, employeeProfile, profile, employeeBankInfo, provinces, application, genderOptions, addlInputs, maritalStatusOptions, changeFormMapping) {
            'ngInject';
            let source = 'application-status';
            $transitions.onSuccess({}, function (transition) {
                source = transition.from().name
                console.log(
                    "Successful Transition from " + transition.from().name +
                    " to " + transition.to().name
                );
            });
            $uibModal.open({
                ...UserProfileModal,
                resolve: {
                    ownerView: () => ownerView,
                    employee: () => employee,
                    employeeProfile: () => employeeProfile,
                    profile: () => profile,
                    employeeBankInfo: () => employeeBankInfo,
                    provinces: () => provinces,
                    application: () => application,
                    genderOptions: () => genderOptions,
                    addlInputs: () => addlInputs,
                    maritalStatusOptions: () => maritalStatusOptions,
                    changeFormMapping: () => changeFormMapping

                }
            }).result.then(function (result) {
                console.log("Modal closed with result", result);
            }).catch(function (reason) {
                console.log("Modal dismissed with reason", reason);
            }).finally(() => {
                if (source === 'root') {
                    $state.transitionTo('root', null, { reload: true });
                } else {
                    $state.transitionTo('application-status', null, { reload: true });
                }
            });
        }]
    }
}, {
    state: "application-status.owner-profile",
    config: {
        url: "/owner/profile/:applicationId",
        component: "apexUserProfileModal",
        data: {
            pageHeader: "User Profile",
            permissionKey: "navigation:applicationStatus"
        },
        params: {
            applicationId: { value: null }
        },
        resolve: {
            ownerView: () => {
                return true;
            },
            applicationId: ['$stateParams', function ($stateParams) {
                return $stateParams.applicationId;
            }],
            application: (applicationId, onboardingDocumentService: OnboardingDocumentService) => {
                'ngInject';
                // Use methods from onboardingDocumentService here
                return onboardingDocumentService.retrieveApplicationById(applicationId);
            },
            employee: (application, employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveEmployeeIdentity(application.EmployeeId);
            },
            owner: (employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveIdentity();
            },
            employeeId: (application) => {
                'ngInject';
                return application.EmployeeId;
            },
            employeeProfile: (employeeId, employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveOnboardingEmployee(employeeId);
            },
            profile: (employeeId, employeeService: EmployeeService) => {
                'ngInject'
                return employeeService.retrieveEmployeeProfile(employeeId);
            },
            employeeBankInfo: (employeeId, employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveEmployeeBankInfo(employeeId); //.then((data) => { return data });
            },
            provinces: (stateProvinceService: StateProvinceService) => {
                'ngInject';
                return stateProvinceService.retrieveStateProvinces();
            },
            genderOptions: (employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveGenders();
            },
            addlInputs: (onboardingDocumentService, employee) => {
                'ngInject';
                return onboardingDocumentService.retrieveAddlInputs(employee.EmployeeID);
            },
            maritalStatusOptions: (employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveMaritalStatuses();
            }
        },
        onEnter: ['$uibModal', '$state', '$transitions', 'ownerView', 'employee', 'employeeProfile', 'profile', 'employeeBankInfo', 'provinces', 'application', 'genderOptions', 'addlInputs', 'owner', 'maritalStatusOptions',
            function ($uibModal, $state, $transitions, ownerView, employee, employeeProfile, profile, employeeBankInfo, provinces, application, genderOptions, addlInputs, owner, maritalStatusOptions) {
                'ngInject';
                let source = 'application-status';
                $transitions.onSuccess({}, function (transition) {
                    source = transition.from().name
                    console.log(
                        "Successful Transition from " + transition.from().name +
                        " to " + transition.to().name
                    );
                });
                $uibModal.open({
                    ...UserProfileModal,
                    resolve: {
                        ownerView: () => ownerView,
                        employee: () => employee,
                        employeeProfile: () => employeeProfile,
                        profile: () => profile,
                        employeeBankInfo: () => employeeBankInfo,
                        provinces: () => provinces,
                        application: () => application,
                        genderOptions: () => genderOptions,
                        addlInputs: () => addlInputs,
                        owner: () => owner,
                        maritalStatusOptions: () => maritalStatusOptions
                    }
                }).result.then(function (result) {
                    console.log("Modal closed with result", result);
                }).catch(function (reason) {
                    console.log("Modal dismissed with reason", reason);
                }).finally(() => {
                    if (source === 'root') {
                        $state.transitionTo('root', null, { reload: true });
                    } else {
                        $state.transitionTo('application-status', null, { reload: true });
                    }
                });
            }]
    }
}, {
    state: "application-status.federalW4",
    config: {
        url: "/federalw4",
        component: "apexFederalW4Modal",
        data: {
            pageHeader: "Federal W4",
            permissionKey: "navigation:applicationStatus"
        },
        params: {
            applicationId: { value: null }
        },
        resolve: {
            ownerView: () => {
                return false;
            },
            //applicationId: ['$stateParams', function ($stateParams) {
            //    return $stateParams.applicationId;
            //}],
            employee: (employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveIdentity();
            },
            employeeId: (employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveIdentity().then(function (emp) {
                    return emp.EmployeeID;
                });
            },
            employeeProfile: (employeeId, employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveOnboardingEmployee(employeeId);
            },
            profile: (employeeId, employeeService: EmployeeService) => {
                'ngInject'
                return employeeService.retrieveEmployeeProfile(employeeId);
            },
            employeeBankInfo: (employeeId, employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveEmployeeBankInfo(employeeId); //.then((data) => { return data });
            },
            provinces: (stateProvinceService: StateProvinceService) => {
                'ngInject';
                return stateProvinceService.retrieveStateProvinces();
            },
            application: (employee, onboardingDocumentService: OnboardingDocumentService) => {
                'ngInject';
                // Use methods from onboardingDocumentService here
                return onboardingDocumentService.reterieveApplication(employee.EmployeeID);
            },
            genderOptions: (employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveGenders();
            },
            userInputs: (employee, onboardingDocumentService: OnboardingDocumentService) => {
                'ngInject';
                return onboardingDocumentService.retrieveUserInput(employee.EmployeeID, "5", "-1")
            },
            savedInputs: (employee, onboardingDocumentService: OnboardingDocumentService) => {
                'ngInject';
                return onboardingDocumentService.retrieveSavedInput(employee.EmployeeID, "5", "-1")
            },
            maritalStatus: (employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveMaritalStatuses();
            },
            addlInputs: (onboardingDocumentService, employee) => {
                'ngInject';
                return onboardingDocumentService.retrieveAddlInputs(employee.EmployeeID);
            }
        },
        onEnter: ['$uibModal', '$state', '$transitions', 'ownerView', 'employee', 'employeeProfile', 'profile', 'employeeBankInfo', 'provinces', 'application', 'genderOptions', 'userInputs', 'savedInputs', 'maritalStatus', 'addlInputs',
            function ($uibModal, $state, $transitions, ownerView, employee, employeeProfile, profile, employeeBankInfo, provinces, application, genderOptions, userInputs, savedInputs, maritalStatus, addlInputs) {
                'ngInject'
                let source = 'application-status';
                $transitions.onSuccess({}, function (transition) {
                    source = transition.from().name
                    console.log(
                        "Successful Transition from " + transition.from().name +
                        " to " + transition.to().name
                    );
                });
                $uibModal.open({
                    ...FederalW4Modal,
                    resolve: {
                        ownerView: () => ownerView,
                        employee: () => employee,
                        employeeProfile: () => employeeProfile,
                        profile: () => profile,
                        employeeBankInfo: () => employeeBankInfo,
                        provinces: () => provinces,
                        application: () => application,
                        genderOptions: () => genderOptions,
                        userInputs: () => userInputs,
                        savedInputs: () => savedInputs,
                        maritalStatus: () => maritalStatus,
                        addlInputs: () => addlInputs
                    }
                }).result.then(function (result) {
                    console.log("Modal closed with result", result);
                }).catch(function (reason) {
                    console.log("Modal dismissed with reason", reason);
                }).finally(() => {
                    if (source === 'root') {
                        $state.transitionTo('root', null, { reload: true });
                    } else {
                        $state.transitionTo('application-status', null, { reload: true });
                    }
                });
            }]
    }
}, {
    state: "application-status.owner-federalW4",
    config: {
        url: "/owner/federalw4/:applicationId",
        component: "apexFederalW4Modal",
        data: {
            pageHeader: "Federal W4",
            permissionKey: "navigation:applicationStatus"
        },
        params: {
            applicationId: { value: null }
        },
        resolve: {
            ownerView: () => {
                return true;
            },
            applicationId: ['$stateParams', function ($stateParams) {
                return $stateParams.applicationId;
            }],
            application: (applicationId, onboardingDocumentService: OnboardingDocumentService) => {
                'ngInject';
                // Use methods from onboardingDocumentService here
                return onboardingDocumentService.retrieveApplicationById(applicationId);
            },
            employee: (application, employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveEmployeeIdentity(application.EmployeeId);
            },
            owner: (employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveIdentity();
            },
            employeeId: (application) => {
                'ngInject';
                return application.EmployeeId;
            },
            employeeProfile: (employeeId, employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveOnboardingEmployee(employeeId);
            },
            profile: (employeeId, employeeService: EmployeeService) => {
                'ngInject'
                return employeeService.retrieveEmployeeProfile(employeeId);
            },
            employeeBankInfo: (employeeId, employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveEmployeeBankInfo(employeeId); //.then((data) => { return data });
            },
            provinces: (stateProvinceService: StateProvinceService) => {
                'ngInject';
                return stateProvinceService.retrieveStateProvinces();
            },
            genderOptions: (employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveGenders();
            },
            userInputs: (employee, onboardingDocumentService: OnboardingDocumentService) => {
                'ngInject';
                return onboardingDocumentService.retrieveUserInput(employee.EmployeeID, "5", "-1")
            },
            maritalStatus: (employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveMaritalStatuses();
            },
            addlInputs: (onboardingDocumentService, employee) => {
                'ngInject';
                return onboardingDocumentService.retrieveAddlInputs(employee.EmployeeID);
            },
            ownerInfo: (employee, icdCorporationService: IcdCorporationService) => {
                'ngInject';
                return icdCorporationService.retrieveIcdCorporation(employee.IcdCorporationID);
            },
            showSignaturePopup: () => {
                return true;
            }
        },
        onEnter: ['$uibModal', '$state', '$transitions', 'ownerView', 'employee', 'employeeProfile', 'profile', 'employeeBankInfo', 'provinces', 'application', 'genderOptions', 'userInputs', 'maritalStatus', 'addlInputs', 'owner', 'ownerInfo', 'showSignaturePopup',
            function ($uibModal, $state, $transitions, ownerView, employee, employeeProfile, profile, employeeBankInfo, provinces, application, genderOptions, userInputs, maritalStatus, addlInputs, owner, ownerInfo, showSignaturePopup) {
                'ngInject'
                let source = 'application-status';
                $transitions.onSuccess({}, function (transition) {
                    source = transition.from().name
                    if (transition.to().name === '') {
                        console.log(
                            "Successful Transition from " + transition.from().name +
                            " to " + transition.to().name
                        );
                    }
                });
                $uibModal.open({
                    ...FederalW4Modal,
                    resolve: {
                        ownerView: () => ownerView,
                        employee: () => employee,
                        employeeProfile: () => employeeProfile,
                        profile: () => profile,
                        employeeBankInfo: () => employeeBankInfo,
                        provinces: () => provinces,
                        application: () => application,
                        genderOptions: () => genderOptions,
                        userInputs: () => userInputs,
                        maritalStatus: () => maritalStatus,
                        addlInputs: () => addlInputs,
                        owner: () => owner,
                        ownerInfo: () => ownerInfo,
                        showSignaturePopup: () => showSignaturePopup
                    }
                }).result.then(function (result) {
                    console.log("Modal closed with result", result);
                }).catch(function (reason) {
                    console.log("Modal dismissed with reason", reason);
                }).finally(() => {
                    if (source === 'root') {
                        $state.transitionTo('root', null, { reload: true });
                    } else {
                        $state.transitionTo('application-status', null, { reload: true });
                    }
                });
            }]
    }
}, {
    state: "application-status.owner-federalW4-preview",
    config: {
        url: "/federal-w4-preview/:applicationId",
        data: {
            pageHeader: "Federal W4 Preview",
            permissionKey: "navigation:applicationStatus"
        },
        params: {
            applicationId: { value: null }
        },
        resolve: {
            applicationId: ['$stateParams', function ($stateParams) {
                return $stateParams.applicationId;
            }],
            application: (applicationId, onboardingDocumentService: OnboardingDocumentService) => {
                'ngInject';
                // Use methods from onboardingDocumentService here
                return onboardingDocumentService.retrieveApplicationById(applicationId);
            },
            employee: (application, employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveEmployeeIdentity(application.EmployeeId);
            },
            owner: (employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveIdentity();
            },
            employeeId: (application) => {
                'ngInject';
                return application.EmployeeId;
            },
            profile: (employeeId, employeeService: EmployeeService) => {
                'ngInject'
                return employeeService.retrieveEmployeeProfile(employeeId);
            },
            employeeProfile: (employeeId, employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveOnboardingEmployee(employeeId);
            },
            userInputs: (employee, onboardingDocumentService: OnboardingDocumentService) => {
                'ngInject';
                return onboardingDocumentService.retrieveUserInput(employee.EmployeeID, "5", "-1")
            },
            provinces: (stateProvinceService: StateProvinceService) => {
                'ngInject';
                return stateProvinceService.retrieveStateProvinces();
            },
            addlInputs: (onboardingDocumentService, employee) => {
                'ngInject';
                return onboardingDocumentService.retrieveAddlInputs(employee.EmployeeID);
            },
            ownerInfo: (employee, icdCorporationService: IcdCorporationService) => {
                'ngInject';
                return icdCorporationService.retrieveIcdCorporation(employee.IcdCorporationID);
            }
        },
        onEnter: ['$uibModal', '$transitions', '$q', '$state', 'utilityService', 'employee', 'profile', 'userInputs', 'provinces', 'addlInputs', 'onboardingDocumentService', 'application', 'ownerInfo', 'employeeProfile', 'owner', function ($uibModal, $transitions, $q, $state, utilityService, employee, profile, userInputs, provinces, addlInputs, onboardingDocumentService, application, ownerInfo, employeeProfile, owner) {
            let source = 'application-status';
            $transitions.onSuccess({}, function (transition) {
                source = transition.from().name
                console.log(
                    "Successful Transition from " + transition.from().name +
                    " to " + transition.to().name
                );
            });
            const wiToggle = addlInputs.WIToggle === "true"
            let formData = {
                RequestTypeId: '5',
                FirstNameMiddleInitial: userInputs.FirstNameMiddleInitial,
                MiddleName: userInputs.MiddleName,
                LastName: userInputs.LastName,
                EmployeeSocialSecurityNumber: userInputs.EmployeeSocialSecurityNumber,
                Address: userInputs.Address,
                City: userInputs.City,
                ZipCode: userInputs.ZipCode,
                State: provinces.find(x => x.Abbr === userInputs.State)?.Abbr,
                Date: moment(userInputs.Date, 'MM/DD/YYYY').format('MM/DD/YYYY'),
                IsI9EmployeeMode: false,
                EmployerName2: "akash kasina",
                Signature: userInputs.Signature,
                ExemptCheck: wiToggle ? "true" : "false",
            };

            if (userInputs != null && userInputs.EmployerNameAddress != null) {
                const savedInfo = {
                    Employername: userInputs.Employername,
                    EmployerAddress: userInputs.EmployerAddress,
                    Employercity: userInputs.Employercity,
                    Employerstate: provinces.find(x => x.StateName === userInputs.Employerstate).Abbr,
                    Employerzip: userInputs.Employerzip,
                    EmployerCityZip: [userInputs.Employercity, provinces.find(x => x.StateName === userInputs.Employerstate).Abbr || "", userInputs.Employerzip].filter(Boolean).join(', '),
                    EmploymentDate: moment(employeeProfile.IcdOffices[0].HireDate, 'DD/MM/YYYY').format('MM/DD/YYYY'),
                    Ein: userInputs.Ein
                }
                formData = { ...formData, ...savedInfo };
            } else if (ownerInfo) {
                const savedInfo = {
                    Employername: ownerInfo.LegalBusinessName || ownerInfo.ClientName,
                    EmployerAddress: [ownerInfo.ShippingAddress.StreetLine1, ownerInfo.ShippingAddress.StreetLine2, ownerInfo.ShippingAddress.AptNum].filter(Boolean).join(', '),
                    Employercity: ownerInfo.ShippingAddress.City,
                    Employerstate: provinces.find(x => x.StateName === ownerInfo.ShippingAddress.StateName).Abbr,
                    Employerzip: ownerInfo.ShippingAddress.PostalCode,
                    EmployerCityZip: [ownerInfo.ShippingAddress.City, provinces.find(x => x.StateName === ownerInfo.ShippingAddress.StateName).Abbr || "", ownerInfo.ShippingAddress.PostalCode].filter(Boolean).join(', '),
                    EmploymentDate: moment(employeeProfile.IcdOffices[0].HireDate, 'DD/MM/YYYY').format('MM/DD/YYYY'),
                    Ein: ownerInfo.FEIN
                }
                formData = { ...formData, ...savedInfo };
            }
            if (!wiToggle) {
                const withholdingData = {
                    MaritalStatus: userInputs.MaritalStatus,
                    MultipleJobs: userInputs.MultipleJobs,
                    Step3QualifyingChildren: Number(userInputs.Step3QualifyingChildren) || 0,
                    Step3Dependents: Number(userInputs.Step3Dependents) || 0,
                    Step3Total: Number(userInputs.Step3Total) || 0,
                    Step4OtherIncome: Number(userInputs.Step4OtherIncome) || 0,
                    Step4Deductions: Number(userInputs.Step4Deductions) || 0,
                    Step4ExtraWithholding: Number(userInputs.Step4ExtraWithholding) || 0,
                }
                formData = { ...formData, ...withholdingData };
            }

            return onboardingDocumentService.previewUrl(employee.UserName, formData, '0').then(function (result) {
                const previewUrl = result;
                return $uibModal.open({
                    ...OwnerPreviewSignatureModal,
                    resolve: {
                        title: () => "Federal-W4 Preview",
                        previewUrl: () => {
                            return previewUrl;
                        },
                        allowApprove: () => {
                            return canApproveForm(application, '5');
                        },
                        allowReview: () => {
                            return canApproveForm(application, '5');
                        },
                        allowSign: () => {
                            return false;
                        }, //for pages without signature
                        previewByPassed: () => {
                            return true;
                        }
                    }
                }).result.then(function (data) {
                    console.log(data);
                    if (data === 'ok') {
                        utilityService.showLoading();
                        const promiseArray = [];
                        const submitApplicationPromise = onboardingDocumentService.submit(employee.UserName, formData, '0');
                        promiseArray.push(submitApplicationPromise);
                        return $q.all(promiseArray);
                    }
                    if (data && data.review) {
                        utilityService.showLoading();
                        const commentPromise = (data.comment && data.comment.trim())
                            ? onboardingDocumentService.saveComment({
                                ApplicationId: application.ApplicationId,
                                UserName: owner.UserName,
                                Text: data.comment,
                            })
                            : $q.resolve();
                        return commentPromise
                            .then(() => onboardingDocumentService.setReviewRequired(employee.EmployeeID, '5'))
                            .then(() => ({ reviewOnly: true }));
                    }
                    return false;
                }).then(function (approve) {
                    console.log(approve);
                    if (!approve || approve.reviewOnly) {
                        return true;
                    }
                    const approvePromise = onboardingDocumentService.approveOnboardingForm(application.ApplicationId, "5");
                    return $q.all(approvePromise);
                }).catch(function (reason) {
                    console.log("Approval dismissed with reason", reason);
                }).finally(() => {
                    utilityService.hideLoading();
                    if (source === 'root') {
                        $state.transitionTo('root', null, { reload: true });
                    } else {
                        $state.transitionTo('application-status', null, { reload: true });
                    }
                });
            })
        }]
    }
}, {
    state: "application-status.w9",
    config: {
        url: "/w9",
        component: "apexW9Modal",
        data: {
            pageHeader: "Federal W9",
            permissionKey: "navigation:applicationStatus"
        },
        params: {
            applicationId: { value: null }
        },
        resolve: {
            ownerView: () => {
                return false;
            },
            employee: (employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveIdentity();
            },
            employeeId: (employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveIdentity().then(function (emp) {
                    return emp.EmployeeID;
                });
            },
            employeeProfile: (employeeId, employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveOnboardingEmployee(employeeId);
            },
            profile: (employeeId, employeeService: EmployeeService) => {
                'ngInject'
                return employeeService.retrieveEmployeeProfile(employeeId);
            },
            employeeBankInfo: (employeeId, employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveEmployeeBankInfo(employeeId); //.then((data) => { return data });
            },
            provinces: (stateProvinceService: StateProvinceService) => {
                'ngInject';
                return stateProvinceService.retrieveStateProvinces();
            },
            application: (employee, onboardingDocumentService: OnboardingDocumentService) => {
                'ngInject';
                // Use methods from onboardingDocumentService here
                return onboardingDocumentService.reterieveApplication(employee.EmployeeID);
            },
            genderOptions: (employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveGenders();
            },
            userInputs: (employee, onboardingDocumentService: OnboardingDocumentService) => {
                'ngInject';
                return onboardingDocumentService.retrieveUserInput(employee.EmployeeID, "-2", "-2")
            },
            savedInputs: (employee, onboardingDocumentService: OnboardingDocumentService) => {
                'ngInject';
                return onboardingDocumentService.retrieveSavedInput(employee.EmployeeID, "-2", "-2")
            },
            maritalStatus: (employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveMaritalStatuses();
            },
            addlInputs: (onboardingDocumentService, employee) => {
                'ngInject';
                return onboardingDocumentService.retrieveAddlInputs(employee.EmployeeID);
            }
        },
        onEnter: ['$uibModal', '$state', '$transitions', 'ownerView', 'employee', 'employeeProfile', 'profile', 'employeeBankInfo', 'provinces', 'application', 'genderOptions', 'userInputs', 'savedInputs', 'maritalStatus', 'addlInputs',
            function ($uibModal, $state, $transitions, ownerView, employee, employeeProfile, profile, employeeBankInfo, provinces, application, genderOptions, userInputs, savedInputs, maritalStatus, addlInputs) {
                'ngInject'
                let source = 'application-status';
                $transitions.onSuccess({}, function (transition) {
                    source = transition.from().name
                    console.log(
                        "Successful Transition from " + transition.from().name +
                        " to " + transition.to().name
                    );
                });
                $uibModal.open({
                    ...W9Modal,
                    resolve: {
                        ownerView: () => ownerView,
                        employee: () => employee,
                        employeeProfile: () => employeeProfile,
                        profile: () => profile,
                        employeeBankInfo: () => employeeBankInfo,
                        provinces: () => provinces,
                        application: () => application,
                        genderOptions: () => genderOptions,
                        userInputs: () => userInputs,
                        savedInputs: () => savedInputs,
                        maritalStatus: () => maritalStatus,
                        addlInputs: () => addlInputs
                    }
                }).result.then(function (result) {
                    console.log("Modal closed with result", result);
                }).catch(function (reason) {
                    console.log("Modal dismissed with reason", reason);
                }).finally(() => {
                    if (source === 'root') {
                        $state.transitionTo('root', null, { reload: true });
                    } else {
                        $state.transitionTo('application-status', null, { reload: true });
                    }
                });
            }]
    }
}, {
    state: "application-status.owner-w9",
    config: {
        url: "/owner/w9/:applicationId",
        component: "apexW9Modal",
        data: {
            pageHeader: "Federal W9",
            permissionKey: "navigation:applicationStatus"
        },
        params: {
            applicationId: { value: null }
        },
        resolve: {
            ownerView: () => {
                return true;
            },
            applicationId: ['$stateParams', function ($stateParams) {
                return $stateParams.applicationId;
            }],
            application: (applicationId, onboardingDocumentService: OnboardingDocumentService) => {
                'ngInject';
                // Use methods from onboardingDocumentService here
                return onboardingDocumentService.retrieveApplicationById(applicationId);
            },
            employee: (application, employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveEmployeeIdentity(application.EmployeeId);
            },
            owner: (employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveIdentity();
            },
            employeeId: (application) => {
                'ngInject';
                return application.EmployeeId;
            },
            employeeProfile: (employeeId, employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveOnboardingEmployee(employeeId);
            },
            profile: (employeeId, employeeService: EmployeeService) => {
                'ngInject'
                return employeeService.retrieveEmployeeProfile(employeeId);
            },
            employeeBankInfo: (employeeId, employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveEmployeeBankInfo(employeeId); //.then((data) => { return data });
            },
            provinces: (stateProvinceService: StateProvinceService) => {
                'ngInject';
                return stateProvinceService.retrieveStateProvinces();
            },
            genderOptions: (employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveGenders();
            },
            userInputs: (employee, onboardingDocumentService: OnboardingDocumentService) => {
                'ngInject';
                return onboardingDocumentService.retrieveUserInput(employee.EmployeeID, "-2", "-2")
            },
            maritalStatus: (employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveMaritalStatuses();
            },
            addlInputs: (onboardingDocumentService, employee) => {
                'ngInject';
                return onboardingDocumentService.retrieveAddlInputs(employee.EmployeeID);
            },
            ownerInfo: (employee, icdCorporationService: IcdCorporationService) => {
                'ngInject';
                return icdCorporationService.retrieveIcdCorporation(employee.IcdCorporationID);
            }
        },
        onEnter: ['$uibModal', '$state', '$transitions', 'ownerView', 'employee', 'employeeProfile', 'profile', 'employeeBankInfo', 'provinces', 'application', 'genderOptions', 'userInputs', 'maritalStatus', 'addlInputs', 'owner', 'ownerInfo',
            function ($uibModal, $state, $transitions, ownerView, employee, employeeProfile, profile, employeeBankInfo, provinces, application, genderOptions, userInputs, maritalStatus, addlInputs, owner, ownerInfo) {
                'ngInject'
                let source = 'application-status';
                $transitions.onSuccess({}, function (transition) {
                    source = transition.from().name
                    console.log(
                        "Successful Transition from " + transition.from().name +
                        " to " + transition.to().name
                    );
                });
                $uibModal.open({
                    ...W9Modal,
                    resolve: {
                        ownerView: () => ownerView,
                        employee: () => employee,
                        employeeProfile: () => employeeProfile,
                        profile: () => profile,
                        employeeBankInfo: () => employeeBankInfo,
                        provinces: () => provinces,
                        application: () => application,
                        genderOptions: () => genderOptions,
                        userInputs: () => userInputs,
                        maritalStatus: () => maritalStatus,
                        addlInputs: () => addlInputs,
                        owner: () => owner,
                        ownerInfo: () => ownerInfo
                    }
                }).result.then(function (result) {
                    console.log("Modal closed with result", result);
                }).catch(function (reason) {
                    console.log("Modal dismissed with reason", reason);
                }).finally(() => {
                    if (source === 'root') {
                        $state.transitionTo('root', null, { reload: true });
                    } else {
                        $state.transitionTo('application-status', null, { reload: true });
                    }
                });
            }]
    }
}, {
    state: "application-status.owner-w9-preview",
    config: {
        url: "/owner-w9-preview/:applicationId",
        data: {
            pageHeader: "Federal W9 Preview",
            permissionKey: "navigation:applicationStatus"
        },
        params: {
            applicationId: { value: null }
        },
        resolve: {
            ownerView: () => {
                return true;
            },
            applicationId: ['$stateParams', function ($stateParams) {
                return $stateParams.applicationId;
            }],
            application: (applicationId, onboardingDocumentService: OnboardingDocumentService) => {
                'ngInject';
                // Use methods from onboardingDocumentService here
                return onboardingDocumentService.retrieveApplicationById(applicationId);
            },
            employee: (application, employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveEmployeeIdentity(application.EmployeeId);
            },
            owner: (employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveIdentity();
            },
            employeeId: (application) => {
                'ngInject';
                return application.EmployeeId;
            },
            employeeProfile: (employeeId, employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveOnboardingEmployee(employeeId);
            },
            profile: (employeeId, employeeService: EmployeeService) => {
                'ngInject'
                return employeeService.retrieveEmployeeProfile(employeeId);
            },
            employeeBankInfo: (employeeId, employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveEmployeeBankInfo(employeeId); //.then((data) => { return data });
            },
            provinces: (stateProvinceService: StateProvinceService) => {
                'ngInject';
                return stateProvinceService.retrieveStateProvinces();
            },
            genderOptions: (employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveGenders();
            },
            userInputs: (employee, onboardingDocumentService: OnboardingDocumentService) => {
                'ngInject';
                return onboardingDocumentService.retrieveUserInput(employee.EmployeeID, "-2", "-2")
            },
            maritalStatus: (employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveMaritalStatuses();
            },
            addlInputs: (onboardingDocumentService, employee) => {
                'ngInject';
                return onboardingDocumentService.retrieveAddlInputs(employee.EmployeeID);
            },
            ownerInfo: (employee, icdCorporationService: IcdCorporationService) => {
                'ngInject';
                return icdCorporationService.retrieveIcdCorporation(employee.IcdCorporationID);
            }
        },
        onEnter: ['$uibModal', '$transitions', '$q', '$state', 'utilityService', 'employee', 'profile', 'userInputs', 'provinces', 'addlInputs', 'onboardingDocumentService', 'application', 'ownerInfo', 'employeeProfile', 'employeeBankInfo', 'owner', function ($uibModal, $transitions, $q, $state, utilityService, employee, profile, userInputs, provinces, addlInputs, onboardingDocumentService, application, ownerInfo, employeeProfile, employeeBankInfo, owner) {
            let source = 'application-status';
            $transitions.onSuccess({}, function (transition) {
                source = transition.from().name
                console.log(
                    "Successful Transition from " + transition.from().name +
                    " to " + transition.to().name
                );
            });
            /*let ssnFein = employeeBankInfo.CurrentSSN ?? employeeBankInfo.CurrentFEIN*/
            //let wiToggle = addlInputs["WIToggle"] === "true"
            //let formData = {
            //    RequestTypeId: '5',
            //    FirstNameMiddleInitial: userInputs.FirstNameMiddleInitial,
            //    MiddleName: userInputs.MiddleName,
            //    LastName: userInputs.LastName,
            //    EmployeeSocialSecurityNumber: userInputs.EmployeeSocialSecurityNumber,
            //    Address: userInputs.Address,
            //    City: userInputs.City,
            //    ZipCode: userInputs.ZipCode,
            //    State: provinces.find(x => x.Abbr === userInputs.State)?.Abbr,
            //    Date: moment(userInputs.Date, 'MM/DD/YYYY').format('MM/DD/YYYY'),
            //    IsI9EmployeeMode: false,
            //    EmployerName2: "akash kasina",
            //    Signature: userInputs.Signature,
            //    ExemptCheck: wiToggle ? "true" : "false",
            //};
            let formData = {
                RequestTypeId: '-2',
                IsI9EmployeeMode: false,
                EntityName: userInputs.EntityName,
                BusinessName: userInputs.BusinessName,
                TaxClassification: userInputs.TaxClassification,
                OwnerTaxClassification: userInputs.OwnerTaxClassification,
                LLCClassification: userInputs.LLCClassification,
                ExemptPayeeCode: userInputs.ExemptPayeeCode,
                ComplianceAct: userInputs.ComplianceAct,
                Line3a: userInputs.Line3a === 'true',
                ReqNameAddress: userInputs.ReqNameAddress,
                AccNos: userInputs.AccNos,
                Address: userInputs.Address,
                City: userInputs.City,
                W9CityState: userInputs.W9CityState,
                State: userInputs.State,
                ZipCode: userInputs.ZipCode,
                Date: moment(userInputs.Date, 'MM/DD/YYYY').format('MM/DD/YYYY'),
                Signature: userInputs.Signature,
            }
            if (employeeBankInfo.CurrentSSN) {
                const ssnData = {
                    Ssn1: employeeBankInfo.CurrentSSN.slice(0, 3),
                    Ssn2: employeeBankInfo.CurrentSSN.slice(3, 5),
                    Ssn3: employeeBankInfo.CurrentSSN.slice(5)
                }
                formData = { ...formData, ...ssnData }
            }
            if (employeeBankInfo.CurrentFEIN) {
                const feinData = {
                    Ein1: employeeBankInfo.CurrentFEIN.slice(0, 2),
                    Ein2: employeeBankInfo.CurrentFEIN.slice(2)
                }
                formData = { ...formData, ...feinData }
            }

            return onboardingDocumentService.previewUrl(employee.UserName, formData, 0).then(function (result) {
                const previewUrl = result;
                return $uibModal.open({
                    ...OwnerPreviewSignatureModal,
                    resolve: {
                        title: () => "Federal-W9 Preview",
                        previewUrl: () => {
                            return previewUrl;
                        },
                        allowApprove: () => {
                            return canApproveForm(application, '-2');
                        },
                        allowReview: () => {
                            return canApproveForm(application, '-2');
                        },
                        allowSign: () => {
                            return false;
                        }, //for pages without signature
                        previewByPassed: () => {
                            return true;
                        }
                    }
                }).result.then(function (data) {
                    console.log(data);
                    if (data === 'ok') {
                        utilityService.showLoading();
                        const promiseArray = [];
                        const submitApplicationPromise = onboardingDocumentService.submit(employee.UserName, formData, 0);
                        promiseArray.push(submitApplicationPromise);
                        return $q.all(promiseArray);
                    }
                    if (data && data.review) {
                        utilityService.showLoading();
                        const commentPromise = (data.comment && data.comment.trim())
                            ? onboardingDocumentService.saveComment({
                                ApplicationId: application.ApplicationId,
                                UserName: owner.UserName,
                                Text: data.comment,
                            })
                            : $q.resolve();
                        return commentPromise
                            .then(() => onboardingDocumentService.setReviewRequired(employee.EmployeeID, '-2'))
                            .then(() => ({ reviewOnly: true }));
                    }
                    return false;
                }).then(function (approve) {
                    console.log(approve);
                    if (!approve || approve.reviewOnly) {
                        return true;
                    }
                    const approvePromise = onboardingDocumentService.approveOnboardingForm(application.ApplicationId, "-2");
                    return $q.all(approvePromise);
                }).catch(function (reason) {
                    console.log("Approval dismissed with reason", reason);
                }).finally(() => {
                    utilityService.hideLoading();
                    if (source === 'root') {
                        $state.transitionTo('root', null, { reload: true });
                    } else {
                        $state.transitionTo('application-status', null, { reload: true });
                    }
                });
            })
        }]
    }
}, {
    state: "application-status.provinceW4",
    config: {
        url: "/statew4",
        component: "apexProvinceW4",
        data: {
            pageHeader: "Province W4",
            permissionKey: "navigation:applicationStatus"
        },
        params: {
            applicationId: { value: null }
        },
        resolve: {
            ownerView: () => {
                return false;
            },
            //applicationId: ['$stateParams', function ($stateParams) {
            //    return $stateParams.applicationId;
            //}],
            stateArr: () => {
                return IMPLEMENTED_PROVINCE_STATE_IDS;
            },
            employee: (employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveIdentity();
            },
            employeeId: (employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveIdentity().then(function (emp) {
                    return emp.EmployeeID;
                });
            },
            employeeProfile: (employeeId, employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveOnboardingEmployee(employeeId);
            },
            profile: (employeeId, employeeService: EmployeeService) => {
                'ngInject'
                return employeeService.retrieveEmployeeProfile(employeeId);
            },
            employeeBankInfo: (employeeId, employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveEmployeeBankInfo(employeeId); //.then((data) => { return data });
            },
            provinceRequired: (stateArr, employeeBankInfo, onboardingDocumentService) => {
                'ngInject';
                const provReq = onboardingDocumentService.checkIfProvinceW4Required(employeeBankInfo.StateToBeTaxedIn);
                return provReq;
            },
            provinces: (stateProvinceService: StateProvinceService) => {
                'ngInject';
                return stateProvinceService.retrieveStateProvinces();
            },
            application: (employee, onboardingDocumentService: OnboardingDocumentService) => {
                'ngInject';
                // Use methods from onboardingDocumentService here
                return onboardingDocumentService.reterieveApplication(employee.EmployeeID);
            },
            genderOptions: (employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveGenders();
            },
            userInputs: (employee, stateArr, provinceRequired, employeeBankInfo, onboardingDocumentService: OnboardingDocumentService) => {
                'ngInject';
                //let stateArr = [5, 6, 7, 9, 19, 34, 65, 9]

                if (provinceRequired && stateArr.includes(employeeBankInfo.StateToBeTaxedIn)) {
                    return onboardingDocumentService.retrieveUserInput(employee.EmployeeID, "2", employeeBankInfo.StateToBeTaxedIn)
                }
                return null;
            },
            savedInputs: (employee, stateArr, provinceRequired, employeeBankInfo, onboardingDocumentService: OnboardingDocumentService) => {
                'ngInject';
                //let stateArr = [5, 6, 7, 9, 19, 34, 65, 9]

                if (provinceRequired && stateArr.includes(employeeBankInfo.StateToBeTaxedIn)) {
                    return onboardingDocumentService.retrieveSavedInput(employee.EmployeeID, "2", employeeBankInfo.StateToBeTaxedIn)
                }
                return null;
            },
            maritalStatus: (employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveMaritalStatuses();
            },
            addlInputs: (onboardingDocumentService, employee) => {
                'ngInject';
                return onboardingDocumentService.retrieveAddlInputs(employee.EmployeeID);
            }
        },
        onEnter: ['$uibModal', '$state', '$transitions', 'ownerView', 'employee', 'employeeProfile', 'profile', 'employeeBankInfo', 'provinces', 'application', 'genderOptions', 'userInputs', 'savedInputs', 'maritalStatus', 'provinceRequired', 'addlInputs', 'onboardingDocumentService', 'utilityService', '$q', 'employeeService'
            , function ($uibModal, $state, $transitions, ownerView, employee, employeeProfile, profile, employeeBankInfo, provinces, application, genderOptions, userInputs, savedInputs, maritalStatus, provinceRequired, addlInputs, onboardingDocumentService, utilityService, $q, employeeService) {
                'ngInject'
                let source = 'application-status';
                $transitions.onSuccess({}, function (transition) {
                    source = transition.from().name
                    console.log(
                        "Successful Transition from " + transition.from().name +
                        " to " + transition.to().name
                    );
                });
                if (!provinceRequired) {
                    alert('Province not required');
                    $state.transitionTo('application-status', { reload: true });
                } else if ((provinces || []).some(p => p.StateProvinceID === employeeBankInfo.StateToBeTaxedIn && p.IsStateExemptOnly)) {
                    utilityService.hideLoading(); // clear the route/fill loader (state-form components do this in $onInit; FormChoiceModal does not)
                    // Exempt-only states (StateProvince.IsStateExemptOnly, e.g. Pennsylvania 40): no employee tax form. Ask the State-Withholding exempt question;
                    // record the choice (New-Hires col AF = StateTaxExempt) and mark ProvinceW4 Submitted
                    // for the owner to approve. Yes = exempt (owner confirms receipt); No = withhold (owner approves).
                    const recordPaChoice = function (isExempt) {
                        employeeBankInfo.StateTaxExempt = isExempt; // New-Hires col AF
                        const chain = $q.resolve()
                            .then(function () {
                                return employeeService.updateEmployeeOnboardingBankInfo(employee.EmployeeID, employeeBankInfo);
                            })
                            .then(function () {
                                return onboardingDocumentService.setAddlInput(employee.EmployeeID, 'StateW4Exempt', isExempt ? 'true' : 'false');
                            })
                            .then(function () {
                                return onboardingDocumentService.markProvinceW4Exempt(employee.EmployeeID);
                            });
                        return utilityService.showLoadingUntilResolved(utilityService.alertOnError(chain, 'Submit failed'));
                    };

                    // Lock once the exempt choice has been recorded (this FORM is Submitted) or approved.
                    // Keyed on the ProvinceW4 form status, NOT the whole application: the pick submits
                    // per-form (markProvinceW4Exempt -> ProvinceW4=Submitted) while the app is still
                    // Started, so the old app-level check left it editable after submission. Editable only
                    // while genuinely open: Pending (initial fill) or ReviewRequired (owner pushed it back);
                    // an Update re-opens it to Pending, Request Review to ReviewRequired.
                    const paLocked = application.ProvinceW4 === 'Submitted' || application.ProvinceW4 === 'Approved';
                    const recordedPaChoice = (addlInputs && addlInputs['StateW4Exempt'] === 'true') ? 'yes'
                        : ((addlInputs && addlInputs['StateW4Exempt'] === 'false') ? 'no' : null);

                    //add support for future other states here- name and other data
                    const askPaExempt = function () {
                        return $uibModal.open({
                            ...FormChoiceModal,
                            resolve: {
                                title: () => (((provinces || []).find(p => p.StateProvinceID === employeeBankInfo.StateToBeTaxedIn) || {}).StateName || 'State') + ' State Withholding',
                                warning: () => 'Do you qualify to be exempt from State Withholding tax?',
                                options: () => ([{ value: 'yes', label: 'Yes, Tax exempt' }, { value: 'no', label: 'No, Withhold taxes' }]),
                                requiredMessage: () => 'Please select an option',
                                defaultValue: () => recordedPaChoice,
                                readOnly: () => paLocked,
                                submitLabel: () => 'Submit',
                                showCancel: () => false
                            }
                        }).result.then(function (choice) {
                            if (choice === 'yes') {
                                return $uibModal.open({
                                    ...FormChoiceModal,
                                    backdrop: true,
                                    keyboard: true,
                                    resolve: {
                                        title: () => 'Confirm Documentation',
                                        warning: () => 'Please confirm that you have completed and provided all appropriate documentation to your employer.',
                                        options: () => ([{ value: 'yes', label: 'I confirm' }]),
                                        useCheckbox: () => true,
                                        requireValue: () => 'yes',
                                        requiredMessage: () => 'You must check the box to confirm before submitting.',
                                        defaultValue: () => null,
                                        submitLabel: () => 'Submit',
                                        showCancel: () => true,
                                        cancelLabel: () => 'Back'
                                    }
                                }).result.then(function () {
                                    return recordPaChoice(true);
                                })
                                    .catch(function () {
                                        return askPaExempt();
                                    }); // Back -> re-ask
                            }
                            return recordPaChoice(false);
                        });
                    };
                    return askPaExempt().catch(function (reason) {
                        console.log('PA exempt flow dismissed', reason);
                    }).finally(() => {
                        if (source === 'root') {
                            $state.transitionTo('root', null, { reload: true });
                        } else {
                            $state.transitionTo('application-status', null, { reload: true });
                        }
                    });
                } else {
                    let state = FederalW4Modal;
                    switch (employeeBankInfo.StateToBeTaxedIn) {
                        case 65:
                            state = ALW4Modal;
                            break;
                        case 19:
                            state = KYW4Modal;
                            break;
                        case 12:
                            state = GAW4Modal;
                            break;
                        case 22:
                            state = MDW4Modal;
                            break;
                        case 34:
                            state = NYW4Modal;
                            break;
                        case 6:
                            state = ARW4Modal;
                            break;
                        case 5:
                            state = AZW4Modal;
                            break;
                        case 7:
                            state = CAW4Modal;
                            break;
                        case 9:
                            state = CTW4Modal;
                            break;
                        case 32:
                            state = NJW4Modal;
                            break;
                        case 35:
                            state = NCW4Modal;
                            break;
                        case 37:
                            state = OHW4Modal;
                            break;
                        case 48:
                            state = VAW4Modal;
                            break;
                        case 15:
                            state = ILW4Modal;
                            break;
                        default:
                            state = BoilerPlateW4Modal;
                    }
                    $uibModal.open({
                        ...state,
                        resolve: {
                            ownerView: () => ownerView,
                            employee: () => employee,
                            employeeProfile: () => employeeProfile,
                            profile: () => profile,
                            employeeBankInfo: () => employeeBankInfo,
                            provinces: () => provinces,
                            application: () => application,
                            genderOptions: () => genderOptions,
                            userInputs: () => userInputs,
                            savedInputs: () => savedInputs,
                            maritalStatus: () => maritalStatus,
                            addlInputs: () => addlInputs
                        }
                    }).result.then(function (result) {
                        console.log("Modal closed with result", result);
                    }).catch(function (reason) {
                        console.log("Modal dismissed with reason", reason);
                    }).finally(() => {
                        if (source === 'root') {
                            $state.transitionTo('root', null, { reload: true });
                        } else {
                            $state.transitionTo('application-status', null, { reload: true });
                        }
                    });
                }
            }]
    }
}, {
    state: "application-status.owner-provinceW4",
    config: {
        url: "/owner/statew4/:applicationId",
        component: "apexProvinceW4",
        data: {
            pageHeader: "State W4/Provincial T4",
            permissionKey: "navigation:applicationStatus"
        },
        params: {
            applicationId: { value: null }
        },
        resolve: {
            ownerView: () => {
                return true;
            },
            applicationId: ['$stateParams', function ($stateParams) {
                return $stateParams.applicationId;
            }],
            application: (applicationId, onboardingDocumentService: OnboardingDocumentService) => {
                'ngInject';
                // Use methods from onboardingDocumentService here
                return onboardingDocumentService.retrieveApplicationById(applicationId);
            },
            employee: (application, employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveEmployeeIdentity(application.EmployeeId);
            },
            owner: (employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveIdentity();
            },
            employeeId: (application) => {
                'ngInject';
                return application.EmployeeId;
            },
            employeeProfile: (employeeId, employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveOnboardingEmployee(employeeId);
            },
            profile: (employeeId, employeeService: EmployeeService) => {
                'ngInject'
                return employeeService.retrieveEmployeeProfile(employeeId);
            },
            employeeBankInfo: (employeeId, employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveEmployeeBankInfo(employeeId); //.then((data) => { return data });
            },
            provinceRequired: (employeeBankInfo, onboardingDocumentService) => {
                'ngInject';
                return onboardingDocumentService.checkIfProvinceW4Required(employeeBankInfo.StateToBeTaxedIn);
            },
            provinces: (stateProvinceService: StateProvinceService) => {
                'ngInject';
                return stateProvinceService.retrieveStateProvinces();
            },
            genderOptions: (employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveGenders();
            },
            userInputs: (employee, provinceRequired, employeeBankInfo, onboardingDocumentService: OnboardingDocumentService) => {
                'ngInject';
                const stateArr = IMPLEMENTED_PROVINCE_STATE_IDS

                if (provinceRequired && stateArr.includes(employeeBankInfo.StateToBeTaxedIn)) {
                    return onboardingDocumentService.retrieveUserInput(employee.EmployeeID, "2", employeeBankInfo.StateToBeTaxedIn)
                }
                return null;
            },
            maritalStatus: (employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveMaritalStatuses();
            },
            addlInputs: (onboardingDocumentService, employee) => {
                'ngInject';
                return onboardingDocumentService.retrieveAddlInputs(employee.EmployeeID);
            },
            ownerInfo: (employee, icdCorporationService: IcdCorporationService) => {
                'ngInject';
                return icdCorporationService.retrieveIcdCorporation(employee.IcdCorporationID);
            },
            stateTaxInfo: (owner, icdCorporationService: IcdCorporationService) => {
                'ngInject';
                return icdCorporationService.retrieveIcdCorporationTaxInfo(owner.IcdCorporationID)
            },
            showSignaturePopup: () => {
                return true;
            },
            ownerOfficeInfo: (owner, icdOfficeService: IcdOfficeService) => {
                'ngInject';
                return icdOfficeService.retrieveIcdOffice(owner.IcdOfficeID);
            }
        },
        onEnter: ['$uibModal', '$state', '$transitions', 'ownerView', 'employee', 'employeeProfile', 'profile', 'employeeBankInfo', 'provinces', 'application', 'genderOptions', 'userInputs', 'maritalStatus', 'provinceRequired', 'owner', 'ownerInfo', 'stateTaxInfo', 'showSignaturePopup', 'ownerOfficeInfo', function ($uibModal, $state, $transitions, ownerView, employee, employeeProfile, profile, employeeBankInfo, provinces, application, genderOptions, userInputs, maritalStatus, provinceRequired, owner, ownerInfo, stateTaxInfo, showSignaturePopup, ownerOfficeInfo) {
            'ngInject'
            let source = 'application-status';
            $transitions.onSuccess({}, function (transition) {
                source = transition.from().name
                console.log(
                    "Successful Transition from " + transition.from().name +
                    " to " + transition.to().name
                );
            });
            if (!provinceRequired) {
                alert('Province not required');
                $state.transitionTo('application-status', { reload: true });
            }


            let state = FederalW4Modal;
            switch (employeeBankInfo.StateToBeTaxedIn) {
                case 65:
                    state = ALW4Modal;
                    break;
                case 19:
                    state = KYW4Modal;
                    break;
                case 12:
                    state = GAW4Modal;
                    break;
                case 22:
                    state = MDW4Modal;
                    break;
                case 34:
                    state = NYW4Modal;
                    break;
                case 6:
                    state = ARW4Modal;
                    break;
                case 5:
                    state = AZW4Modal;
                    break;
                case 7:
                    state = CAW4Modal;
                    break;
                case 9:
                    state = CTW4Modal;
                    break;
                case 32:
                    state = NJW4Modal;
                    break;
                case 35:
                    state = NCW4Modal;
                    break;
                case 37:
                    state = OHW4Modal;
                    break;
                case 48:
                    state = VAW4Modal;
                    break;
                case 15:
                    state = ILW4Modal;
                    break;
                default:
                    state = BoilerPlateW4Modal;
            }
            $uibModal.open({
                ...state,
                resolve: {
                    ownerView: () => ownerView,
                    employee: () => employee,
                    employeeProfile: () => employeeProfile,
                    profile: () => profile,
                    employeeBankInfo: () => employeeBankInfo,
                    provinces: () => provinces,
                    application: () => application,
                    genderOptions: () => genderOptions,
                    userInputs: () => userInputs,
                    maritalStatus: () => maritalStatus,
                    owner: () => owner,
                    ownerInfo: () => ownerInfo,
                    stateTaxInfo: () => stateTaxInfo,
                    showSignaturePopup: () => showSignaturePopup,
                    ownerOfficeInfo: () => ownerOfficeInfo
                }
            }).result.then(function (result) {
                console.log("Modal closed with result", result);
            }).catch(function (reason) {
                console.log("Modal dismissed with reason", reason);
            }).finally(() => {
                if (source === 'root') {
                    $state.transitionTo('root', null, { reload: true });
                } else {
                    $state.transitionTo('application-status', null, { reload: true });
                }
            });
        }]
    }
}, {
    state: "application-status.owner-provinceW4-preview",
    config: {
        url: "/owner/statew4-preview/:applicationId",
        data: {
            pageHeader: "State W4/Provincial T4 Preview",
            permissionKey: "navigation:applicationStatus"
        },
        params: {
            applicationId: { value: null }
        },
        resolve: {
            applicationId: ['$stateParams', function ($stateParams) {
                return $stateParams.applicationId;
            }],
            application: (applicationId, onboardingDocumentService: OnboardingDocumentService) => {
                'ngInject';
                // Use methods from onboardingDocumentService here
                return onboardingDocumentService.retrieveApplicationById(applicationId);
            },
            employee: (application, employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveEmployeeIdentity(application.EmployeeId);
            },
            owner: (employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveIdentity();
            },
            employeeId: (application) => {
                'ngInject';
                return application.EmployeeId;
            },
            profile: (employeeId, employeeService: EmployeeService) => {
                'ngInject'
                return employeeService.retrieveEmployeeProfile(employeeId);
            },
            employeeProfile: (employeeId, employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveOnboardingEmployee(employeeId);
            },
            employeeBankInfo: (employeeId, employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveEmployeeBankInfo(employeeId); //.then((data) => { return data });
            },
            provinceRequired: (employeeBankInfo, onboardingDocumentService) => {
                'ngInject';
                return onboardingDocumentService.checkIfProvinceW4Required(employeeBankInfo.StateToBeTaxedIn);
            },
            provinces: (stateProvinceService: StateProvinceService) => {
                'ngInject';
                return stateProvinceService.retrieveStateProvinces();
            },
            genderOptions: (employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveGenders();
            },
            maritalStatus: (employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveMaritalStatuses();
            },
            userInputs: (employee, provinceRequired, employeeBankInfo, onboardingDocumentService: OnboardingDocumentService) => {
                'ngInject';
                const stateArr = IMPLEMENTED_PROVINCE_STATE_IDS

                if (provinceRequired && stateArr.includes(employeeBankInfo.StateToBeTaxedIn)) {
                    return onboardingDocumentService.retrieveUserInput(employee.EmployeeID, "2", employeeBankInfo.StateToBeTaxedIn)
                }
                return null;
                //return onboardingDocumentService.retrieveUserInput(employee.EmployeeID, "5", "-1")
            },
            addlInputs: (onboardingDocumentService, employee) => {
                'ngInject';
                return onboardingDocumentService.retrieveAddlInputs(employee.EmployeeID);
            },
            ownerInfo: (employee, icdCorporationService: IcdCorporationService) => {
                'ngInject';
                return icdCorporationService.retrieveIcdCorporation(employee.IcdCorporationID);
            },
            stateTaxInfo: (owner, icdCorporationService: IcdCorporationService) => {
                'ngInject';
                return icdCorporationService.retrieveIcdCorporationTaxInfo(owner.IcdCorporationID)
            },
        },
        onEnter: ['$uibModal', '$transitions', '$q', '$state', 'utilityService', 'employee', 'profile', 'userInputs', 'provinces', 'addlInputs', 'onboardingDocumentService', 'application', 'ownerInfo', 'employeeProfile', 'provinceRequired', 'employeeBankInfo', 'owner', 'stateTaxInfo', function ($uibModal, $transitions, $q, $state, utilityService, employee, profile, userInputs, provinces, addlInputs, onboardingDocumentService, application, ownerInfo, employeeProfile, provinceRequired, employeeBankInfo, owner, stateTaxInfo) {
            let source = 'application-status';
            $transitions.onSuccess({}, function (transition) {
                source = transition.from().name
                console.log(
                    "Successful Transition from " + transition.from().name +
                    " to " + transition.to().name
                );
            });
            if (!provinceRequired) {
                alert('Province not required');
                $state.transitionTo('application-status', { reload: true });
            }
            
            // APEX-321: exempt/nonresident opt-out keyed solely on the StateW4Exempt flag (authoritative;
            // resident submit clears it) so editing an already-submitted form to opt out works like a fresh one.
            const stateW4Choice = addlInputs ? addlInputs['StateW4Exempt'] : undefined;
            // Formless (PA) exempt/withhold: the owner may approve only while the backend would
            // actually act - ApplicationStatus in {Submitted, Review} AND the form not yet Approved
            // (see ApproveOnboardingForm: the ApplicationStatus guard + ProfileCheck). Once the form
            // is Approved, or the application itself is Approved, show a read-only notice instead of
            // the approve modal so it can't be approved again. Mirrors the non-formless allowApprove.
            const paCanApprove = canApproveForm(application, '2');
            if ((stateW4Choice === 'true' || stateW4Choice === 'false') && !paCanApprove) {
                utilityService.hideLoading();
                return $uibModal.open({
                    ...InfoModal,
                    resolve: {
                        notification: () => stateW4Choice === 'true'
                            ? 'This employee has already been approved as exempt from State Withholding tax. No further action is needed.'
                            : 'This employee has already been approved to have State Income Tax withheld. No further action is needed.',
                        showCancel: () => false,
                        continue: () => 'Close'
                    }
                }).result.catch(function (reason) {
                    console.log('PA already-approved notice dismissed', reason);
                }).finally(() => {
                    if (source === 'root') {
                        $state.transitionTo('root', null, { reload: true });
                    } else {
                        $state.transitionTo('application-status', null, { reload: true });
                    }
                });
            }

            if (stateW4Choice === 'true') {
                utilityService.hideLoading();
                return $uibModal.open({
                    ...FormChoiceModal,
                    backdrop: true,
                    keyboard: true,
                    resolve: {
                        title: () => 'Confirm Receipt',
                        warning: () => 'Please confirm that you have received all appropriate forms from your employee. Reminder that tax forms need to be kept for 7 years. Do ensure that it is stored in a safe place.',
                        options: () => ([{ value: 'yes', label: 'I confirm' }]),
                        useCheckbox: () => true,
                        requiredMessage: () => 'You must check the box to confirm before approving.',
                        requireValue: () => 'yes',
                        defaultValue: () => null,
                        submitLabel: () => 'Approve',
                        showCancel: () => true,
                        cancelLabel: () => 'Close'
                    }
                }).result.then(function () {
                    // showLoadingUntilResolved pairs show/hide itself (manual showLoading left the spinner stuck).
                    const approve = onboardingDocumentService.approveOnboardingForm(application.ApplicationId, '2');
                    return utilityService.showLoadingUntilResolved(utilityService.alertOnError(approve, 'Approval Failed'));
                }).catch(function (reason) {
                    console.log('Exempt approval dismissed', reason);
                }).finally(() => {
                    if (source === 'root') {
                        $state.transitionTo('root', null, { reload: true });
                    } else {
                        $state.transitionTo('application-status', null, { reload: true });
                    }
                });
            }

            // Withhold (formless state, e.g. PA): the employee elected withholding. The owner
            // approves directly via a button (no PDF preview, no receipt confirmation).
            if (stateW4Choice === 'false') {
                utilityService.hideLoading();
                return $uibModal.open({
                    ...InfoModal,
                    resolve: {
                        notification: () => 'This employee has elected to have State Income Tax to be withheld. Please confirm that this is correct.',
                        showCancel: () => true,
                        continue: () => 'Confirm'
                    }
                }).result.then(function (data) {
                    if (data !== 'ok') {
                        return;
                    }
                    const approve = onboardingDocumentService.approveOnboardingForm(application.ApplicationId, '2');
                    return utilityService.showLoadingUntilResolved(utilityService.alertOnError(approve, 'Approval Failed'));
                }).catch(function (reason) {
                    console.log('Withhold approval dismissed', reason);
                }).finally(() => {
                    if (source === 'root') {
                        $state.transitionTo('root', null, { reload: true });
                    } else {
                        $state.transitionTo('application-status', null, { reload: true });
                    }
                });
            }

            //build data to preview
            let formData = {};
            let ownerData = {};
            let stateCode = '';
            let state = OwnerPreviewSignatureModal;
            switch (employeeBankInfo.StateToBeTaxedIn) {
                case 32:
                    //state = ALW4Modal;
                    stateCode = 'NJ';
                    formData = {
                        RequestTypeId: '2',
                        EmployeeFirstNameMiddleInitialLastName: userInputs.EmployeeFirstNameMiddleInitialLastName,
                        EmployeeStreetAddress1StreetAddress2: userInputs.EmployeeStreetAddress1StreetAddress2,
                        EmployeeSocialSecurityNumber: userInputs.EmployeeSocialSecurityNumber,
                        EmployeeCity: userInputs.EmployeeCity,
                        EmployeeState: userInputs.EmployeeState,
                        EmployeeZip: userInputs.EmployeeZip,
                        FilingStatus: userInputs.FilingStatus,
                        WageChart: userInputs.WageChart,
                        TotalAllowances: Number(userInputs.TotalAllowances) || 0,
                        AdditionalStateWithholding: Number(userInputs.AdditionalStateWithholding) || 0,
                        Exempt: userInputs.Exempt,
                        Date: moment(userInputs.Date, 'MM/DD/YYYY').format('MM/DD/YYYY'),
                        Signature: userInputs.Signature
                    };
                    if (userInputs != null && userInputs.Employername != null) {
                        ownerData = {
                            Employername: userInputs.Employername,
                            EIN: userInputs.EIN
                        }
                    } else {
                        if (ownerInfo.ShippingAddress) {
                            var employerNameAddress = [ownerInfo.LegalBusinessName || ownerInfo.ClientName, ownerInfo.ShippingAddress.StreetLine1, ownerInfo.ShippingAddress.StreetLine2, ownerInfo.ShippingAddress.AptNum, ownerInfo.ShippingAddress.City, ownerInfo.ShippingAddress.StateName, ownerInfo.ShippingAddress.PostalCode, ownerInfo.ShippingAddress.CountryName].filter(Boolean).join(', ');
                        }
                        const sit = stateTaxInfo?.find(x => x.State === String(employeeBankInfo?.StateToBeTaxedIn) && x.Name === 'State Income Tax');
                        const eid = sit?.Value ?? '';
                        ownerData = {
                            Employername: employerNameAddress,
                            EIN: eid
                        }
                    }
                    formData = { ...formData, ...ownerData };
                    break;
                case 35:
                    stateCode = 'NC';
                    formData = {
                        RequestTypeId: '2',
                        EmployeeFirstName: userInputs.EmployeeFirstName,
                        EmployeeMiddleInitial: userInputs.EmployeeMiddleInitial,
                        EmployeeLastName: userInputs.EmployeeLastName,
                        EmployeeSSN1: userInputs.EmployeeSSN1,
                        EmployeeSSN2: userInputs.EmployeeSSN2,
                        EmployeeSSN3: userInputs.EmployeeSSN3,
                        EmployeeAddress: userInputs.EmployeeAddress,
                        EmployeeCounty: userInputs.EmployeeCounty,
                        EmployeeCity: userInputs.EmployeeCity,
                        EmployeeState: userInputs.EmployeeState,
                        EmployeeZip: userInputs.EmployeeZip,
                        EmployeeCountry: userInputs.EmployeeCountry,
                        FilingStatus: userInputs.FilingStatus,
                        TotalAllowances: userInputs.TotalAllowances,
                        AdditionalStateWithholding: userInputs.AdditionalStateWithholding,
                        ExemptionYear: userInputs.ExemptionYear,
                        Exempt1: userInputs.Exempt1,
                        Exempt2: userInputs.Exempt2,
                        Exempt3: userInputs.Exempt3,
                        ExemptRevoke: userInputs.ExemptRevoke,
                        RevokeLine3: userInputs.RevokeLine3,
                        RevokeLine4: userInputs.RevokeLine4,
                        RevokeLine5: userInputs.RevokeLine5,
                        Date: userInputs.Date,
                        Signature: userInputs.Signature
                    };
                    break;
                case 37:
                    stateCode = 'OH';
                    formData = {
                        RequestTypeId: '2',
                        FullName: userInputs.FullName,
                        EmployeeSocialSecurityNumber: userInputs.EmployeeSocialSecurityNumber,
                        EmployeeAddress: userInputs.EmployeeAddress,
                        SchoolDistrictOfResidence: userInputs.SchoolDistrictOfResidence,
                        SchoolDistrictNumber: userInputs.SchoolDistrictNumber,
                        DependentWithholding: userInputs.DependentWithholding,
                        SeparateWithholding: userInputs.SeparateWithholding,
                        NumberOfDependents: userInputs.NumberOfDependents,
                        TotalWithholdingExemptions: userInputs.TotalWithholdingExemptions,
                        AdditionalStateWithholding: userInputs.AdditionalStateWithholding,
                        FullYearResident: userInputs.FullYearResident,
                        ResidentMilitary: userInputs.ResidentMilitary,
                        NonresidentMilitary: userInputs.NonresidentMilitary,
                        NonresidentCivilianSpouse: userInputs.NonresidentCivilianSpouse,
                        Exempt: userInputs.Exempt,
                        Date: userInputs.Date,
                        Signature: userInputs.Signature
                    };
                    break;
                case 48:
                    stateCode = 'VA';
                    formData = {
                        RequestTypeId: '2',
                        FullName: userInputs.FullName,
                        EmployeeSocialSecurityNumber: userInputs.EmployeeSocialSecurityNumber,
                        EmployeeAddress: userInputs.EmployeeAddress,
                        EmployeeCity: userInputs.EmployeeCity,
                        EmployeeState: userInputs.EmployeeState,
                        EmployeeZip: userInputs.EmployeeZip,
                        PersonalExemptions: userInputs.PersonalExemptions,
                        AgeBlindnessExemptions: userInputs.AgeBlindnessExemptions,
                        TotalExemptions: userInputs.TotalExemptions,
                        AdditionalStateWithholding: userInputs.AdditionalStateWithholding,
                        NotSubjectToWithholding: userInputs.NotSubjectToWithholding,
                        MilitarySpouseExempt: userInputs.MilitarySpouseExempt,
                        Date: userInputs.Date,
                        Signature: userInputs.Signature
                    };
                    break;
                case 15:
                    stateCode = 'IL';
                    formData = {
                        RequestTypeId: '2',
                        FullName: userInputs.FullName,
                        EmployeeSocialSecurityNumber: userInputs.EmployeeSocialSecurityNumber,
                        EmployeeAddress: userInputs.EmployeeAddress,
                        EmployeeCity: userInputs.EmployeeCity,
                        EmployeeState: userInputs.EmployeeState,
                        EmployeeZip: userInputs.EmployeeZip,
                        BasicAllowances: userInputs.BasicAllowances,
                        AdditionalAllowances: userInputs.AdditionalAllowances,
                        AdditionalStateWithholding: userInputs.AdditionalStateWithholding,
                        Exempt: userInputs.Exempt,
                        Date: userInputs.Date,
                        Signature: userInputs.Signature
                    };
                    break;
                case 65:
                    //state = ALW4Modal;
                    stateCode = 'AL';
                    formData = {
                        RequestTypeId: '2',
                        EmployeeFirstNameMiddleInitialLastName: userInputs.EmployeeFirstNameMiddleInitialLastName,
                        EmployeeSocialSecurityNumber: userInputs.EmployeeSocialSecurityNumber,
                        EmployeeStreetAddress1StreetAddress2: userInputs.EmployeeStreetAddress1StreetAddress2,
                        EmployeeCity: userInputs.EmployeeCity,
                        EmployeeState: userInputs.EmployeeState,
                        EmployeeZip: userInputs.EmployeeZip,
                        FilingStatusLine1: userInputs.FilingStatusLine1 === '0' ? 0 : '',
                        FilingStatusLine2: (userInputs.FilingStatusLine2 === 'S' || userInputs.FilingStatusLine2 === 'MS') ? userInputs.FilingStatusLine2 : '',
                        FilingStatusLine3: (userInputs.FilingStatusLine3 === 'H' || userInputs.FilingStatusLine3 === 'M') ? userInputs.FilingStatusLine3 : '',
                        Dependents: userInputs.Dependents !== 0 ? Number(userInputs.Dependents) : '',
                        AdditionalStateWithholding: userInputs.AdditionalStateWithholding !== 0 ? Number(userInputs.AdditionalStateWithholding) : '',
                        TotalExemptions: userInputs.TotalExemptions !== 0 ? Number(userInputs.TotalExemptions) : '',
                        Date: moment(userInputs.Date, 'MM/DD/YYYY').format('DD/MM/YYYY'),
                        Signature: userInputs.Signature
                    };
                    if (userInputs != null && userInputs.Employername != null) {
                        ownerData = {
                            Employername: userInputs.Employername,
                            EmployerfederalEIN: userInputs.EmployerfederalEIN,
                            EmployerstreetAddress1streetAddress2: userInputs.EmployerstreetAddress1streetAddress2,
                            Employercity: userInputs.Employercity,
                            Employerstate: provinces.find(x => x.StateName === userInputs.Employerstate).Abbr,
                            Employerzip: userInputs.Employerzip
                        }
                    } else {
                        ownerData = {
                            Employername: ownerInfo.LegalBusinessName || ownerInfo.ClientName,
                            EmployerfederalEIN: ownerInfo.FEIN,
                            EmployerstreetAddress1streetAddress2: [ownerInfo.ShippingAddress.StreetLine1, ownerInfo.ShippingAddress.StreetLine2, ownerInfo.ShippingAddress.AptNum].filter(Boolean).join(', '),
                            Employercity: ownerInfo.ShippingAddress.City,
                            Employerstate: provinces.find(x => x.StateName === ownerInfo.ShippingAddress.StateName).Abbr,
                            Employerzip: ownerInfo.ShippingAddress.PostalCode
                        }
                    }
                    formData = { ...formData, ...ownerData };
                    break;
                case 19:
                    //state = KYW4Modal;
                    stateCode = 'KY';
                    formData = {
                        RequestTypeId: '2',
                        IsI9EmployeeMode: false,
                        EmployeeFirstNameMiddleInitialLastName: userInputs.EmployeeFirstNameMiddleInitialLastName,
                        Ssn1: userInputs.Ssn1,
                        Ssn2: userInputs.Ssn2,
                        Ssn3: userInputs.Ssn3,
                        EmployeeStreetaddress1Streetaddress2: userInputs.EmployeeStreetAddress1StreetAddress2,
                        EmployeeCity: userInputs.EmployeeCity,
                        EmployeeState: provinces.find(x => x.Abbr === userInputs.EmployeeState).Abbr,
                        EmployeeZip: userInputs.EmployeeZip,
                        AdditionalStateWithholding: userInputs.AdditionalStateWithholding != null ? Number(userInputs.AdditionalStateWithholding) : 0 || 0,
                        ResidentState: userInputs.ResidentState,
                        KYNoTaxLiability: userInputs.KYNoTaxLiability,
                        FortCampbell: userInputs.FortCampbell,
                        MilitarySpouse: userInputs.MilitarySpouse,
                        ReciprocalResident: userInputs.ReciprocalResident,
                        Date: moment(userInputs.Date, 'MM/DD/YYYY').format('DD/MM/YYYY'),
                        Signature: userInputs.Signature
                    };
                    break;
                case 34:
                    //state = NYW4Modal;
                    stateCode = 'NY';
                    formData = {
                        RequestTypeId: '2',
                        IsI9EmployeeMode: false,
                        EmployeeFirstNameMiddleInitial: userInputs.EmployeeFirstNameMiddleInitial,
                        EmployeeLastName: userInputs.EmployeeLastName,
                        EmployeeSocialSecurityNumber: userInputs.EmployeeSocialSecurityNumber,
                        EmployeeStreetaddress1Streetaddress2: userInputs.EmployeeStreetaddress1Streetaddress2,
                        ApartmentNumber: userInputs.ApartmentNumber,
                        EmployeeCity: userInputs.EmployeeCity,
                        EmployeeState: provinces.find(x => x.Abbr === userInputs.EmployeeState).Abbr,
                        EmployeeZip: userInputs.EmployeeZip,
                        FilingStatus: userInputs.FilingStatus,
                        ResidentNYC: userInputs.ResidentNYC,
                        ResidentYonkers: userInputs.ResidentYonkers,
                        TotalAllowances: userInputs.TotalAllowances,
                        TotalAllowancesNYC: userInputs.TotalAllowancesNYC,
                        AdditionalStateWithholding: userInputs.AdditionalStateWithholding,
                        AdditionalNYCWithholding: userInputs.AdditionalNYCWithholding,
                        AdditionalYonkersWithholding: userInputs.AdditionalYonkersWithholding,
                        Date: moment(userInputs.Date, 'MM/DD/YYYY').format('DD/MM/YYYY'),
                        Signature: userInputs.Signature
                    };
                    if (userInputs != null && userInputs.EmployerBusinessAddress != null) {
                        ownerData = {
                            EmployeeClaimsMoreThan14Exemption: userInputs.EmployeeClaimsMoreThan14Exemption,
                            EmployeeIsANewHire: userInputs.EmployeeIsANewHire,
                            ServiceDate: moment(userInputs.hireDate, 'MM-DD-YYYY').format('MM-DD-YYYY'),
                            InsuranceBenefits: userInputs.InsuranceBenefits,
                            EmpQualifyDate: moment(userInputs.qualificationDate, 'MM-DD-YYYY').format('MM-DD-YYYY'),
                            Employername: userInputs.Employername,
                            EmployerfederalEIN: userInputs.EmployerfederalEIN
                        };
                    } else {
                        ownerData = {
                            Employername: ownerInfo.LegalBusinessName || ownerInfo.ClientName,
                            EmployerfederalEIN: ownerInfo.FEIN
                        };
                    }
                    formData = { ...formData, ...ownerData };
                    break;
                case 6:
                    //state = ARW4Modal;
                    stateCode = 'AR';
                    formData = {
                        RequestTypeId: '2',
                        IsI9EmployeeMode: false,
                        EmployeeFirstNameMiddleInitialLastName: userInputs.EmployeeFirstNameMiddleInitialLastName,
                        EmployeeSocialSecurityNumber: userInputs.EmployeeSocialSecurityNumber,
                        EmployeeStreetAddress1StreetAddress2: userInputs.EmployeeStreetAddress1StreetAddress2,
                        EmployeeCity: userInputs.EmployeeCity,
                        EmployeeState: provinces.find(x => x.Abbr === userInputs.EmployeeState).Abbr,
                        EmployeeZip: userInputs.EmployeeZip,
                        PersonalExemption: userInputs.PersonalExemption,
                        MarriedExemption: userInputs.MarriedExemption,
                        HeadOfHouseholdExemption: userInputs.HeadOfHouseholdExemption,
                        Dependents: userInputs.Dependents,
                        AdditionalStateWithholding: userInputs.AdditionalStateWithholding,
                        TotalAllowances: userInputs.TotalAllowances,
                        ExemptionCheckbox: userInputs.ExemptionCheckbox,
                        Date: moment(userInputs.Date, 'DD/MM/YYYY').format('MM/DD/YYYY'),
                        Signature: userInputs.Signature,
                        FilingStatus: userInputs.FilingStatus,
                        LowIncomeTaxRates: userInputs.LowIncomeTaxRates
                    };
                    break;
                case 5:
                    //state = AZW4Modal;
                    stateCode = 'AZ';
                    formData = {
                        RequestTypeId: '2',
                        IsI9EmployeeMode: false,
                        EmployeeFirstNameMiddleInitialLastName: userInputs.EmployeeFirstNameMiddleInitialLastName,
                        EmployeeSocialSecurityNumber: userInputs.EmployeeSocialSecurityNumber,
                        EmployeeStreetAddress1StreetAddress2: userInputs.EmployeeStreetAddress1StreetAddress2,
                        EmployeeCity: userInputs.EmployeeCity,
                        EmployeeState: provinces.find(x => x.Abbr === userInputs.EmployeeState).Abbr,
                        EmployeeZip: userInputs.EmployeeZip,
                        TaxLiability: userInputs.TaxLiability,
                        PercentState: userInputs.PercentState,
                        AdditionalWithHoldingCheckbox: userInputs.AdditionalWithHoldingCheckbox != null,
                        AdditionalStateWithholding: userInputs.AdditionalStateWithholding != null ? Number(userInputs.AdditionalStateWithholding) : 0,
                        NoTaxLiability: !userInputs.NoTaxLiability,
                        Date: moment(userInputs.Date, 'MM/DD/YYYY').format('DD/MM/YYYY'),
                        Signature: userInputs.Signature
                    };
                    break;
                case 7:
                    //state = CAW4Modal;
                    stateCode = 'CA';
                    formData = {
                        RequestTypeId: '2',
                        IsI9EmployeeMode: false,
                        FullName: userInputs.FullName,
                        EmployeeSocialSecurityNumber: userInputs.EmployeeSocialSecurityNumber,
                        Address: userInputs.Address,
                        City: userInputs.City,
                        State: userInputs.State,
                        ZipCode: userInputs.ZipCode,
                        FilingStatus: userInputs.FilingStatus,
                        RegularWithholdingAllowance: Number(userInputs.RegularWithholdingAllowance) || 0,
                        EstimatedDeductions: Number(userInputs.EstimatedDeductions) || 0,
                        TotalAllowances: Number(userInputs.TotalAllowances) || 0,
                        AddlAmount: Number(userInputs.AddlAmount) || 0,
                        WHexempt: userInputs.WHexempt,
                        NotSubj2WH: userInputs.NotSubj2WH,
                        Date: moment(userInputs.Date, 'MM/DD/YYYY').format('MM/DD/YYYY'),
                        Signature: userInputs.Signature,
                    };
                    if (userInputs != null && userInputs.Employername != null) {
                        ownerData = {
                            CaliforniaEmpTaxAccNo: userInputs.CaliforniaEmpTaxAccNo,
                            Employername: userInputs.Employername
                        }
                    } else {
                        const sit = stateTaxInfo?.find(x => x.State === String(employeeBankInfo?.StateToBeTaxedIn) && x.Name === 'State Income Tax');
                        ownerData = {
                            CaliforniaEmpTaxAccNo: sit?.Value ?? '',
                            Employername: [ownerInfo.LegalBusinessName || ownerInfo.ClientName, ownerInfo.ShippingAddress.StreetLine1, ownerInfo.ShippingAddress.StreetLine2, ownerInfo.ShippingAddress.AptNum, ownerInfo.ShippingAddress.City, ownerInfo.ShippingAddress.StateName, ownerInfo.ShippingAddress.PostalCode, ownerInfo.ShippingAddress.CountryName].filter(Boolean).join(', ')
                        }
                    }
                    formData = { ...formData, ...ownerData }
                    break;
                case 9:
                    //state = CTW4Modal;
                    stateCode = 'CT';
                    formData = {
                        RequestTypeId: '2',
                        FirstName: userInputs.FirstName,
                        MiddleName: userInputs.MiddleName,
                        LastName: userInputs.LastName,
                        SocialSecurityNumber: userInputs.SocialSecurityNumber,
                        EmployeeStreetAddress1StreetAddress2: userInputs.EmployeeStreetAddress1StreetAddress2,
                        EmployeeCity: userInputs.EmployeeCity,
                        EmployeeState: userInputs.EmployeeState,
                        EmployeeZip: userInputs.EmployeeZip,
                        WithHold: userInputs.WithHold,
                        AdditionalWithHolding: Number(userInputs.AdditionalWithholding) || 0,
                        ReducedWithholding: Number(userInputs.ReducedWithholding) || 0,
                        Checkifyouareclaiming: userInputs.Checkifyouareclaiming,
                        Residencedomicile: userInputs.Residencedomicile,
                        Signature: userInputs.Signature,
                        Date: moment(userInputs.Date, 'DD/MM/YYYY').format('DD/MM/YYYY')
                    }
                    if (userInputs != null && userInputs.EmployerName != null) {
                        ownerData = {
                            NewHired: userInputs.NewHired === 'yes' ? 'true' : 'false',
                            EmployerName: userInputs.EmployerName,
                            FederalEmployeeNumber: userInputs.FederalEmployeeNumber,
                            EmployerBusinessName: userInputs.EmployerBusinessName,
                            Employersbusinessaddress: userInputs.Employersbusinessaddress,
                            Employercity: userInputs.Employercity,
                            Employerstate: userInputs.Employerstate,
                            Employerzip: userInputs.Employerzip,
                            Contactperson: userInputs.Contactperson,
                            Telephonenumber: userInputs.Telephonenumber,
                            Datehired: moment(userInputs.Datehired, 'MM/DD/YYYY').format('MM/DD/YYYY')
                        }
                    } else {
                        ownerData = {
                            //NewHired: userInputs.neworrehired === 'true' ? 'yes' : 'no',
                            EmployerName: ownerInfo.LegalBusinessName || ownerInfo.ClientName,
                            FederalEmployeeNumber: ownerInfo.FEIN,
                            EmployerBusinessName: ownerInfo.LegalBusinessName || ownerInfo.ClientName,
                            Employersbusinessaddress: [ownerInfo.ShippingAddress.StreetLine1, ownerInfo.ShippingAddress.StreetLine2, ownerInfo.ShippingAddress.AptNum].filter(Boolean).join(', '),
                            Employercity: ownerInfo.ShippingAddress.City,
                            Employerstate: ownerInfo.ShippingAddress.StateName,
                            Employerzip: ownerInfo.ShippingAddress.PostalCode,
                            Contactperson: ownerInfo.Owner,
                            Telephonenumber: owner.PhoneNumber,
                            Datehired: moment(employeeProfile.IcdOffices[0].HireDate, 'DD/MM/YYYY').format('MM/DD/YYYY')
                        }
                    }
                    formData = { ...formData, ...ownerData };
                    break;
                case 12:
                    stateCode = 'GA';
                    formData = {
                        RequestTypeId: '2',
                        FullName: userInputs.FullName,
                        EmployeeSocialSecurityNumber: userInputs.EmployeeSocialSecurityNumber,
                        HomeAddress: userInputs.HomeAddress,
                        CityStateZip: userInputs.CityStateZip,
                        MaritalStatus: userInputs.MaritalStatus,
                        DependentAllowances: userInputs.DependentAllowances,
                        TotalAllowances: userInputs.TotalAllowances,
                        AdditionalWithholding: userInputs.AdditionalWithholding,
                        StateWithholding: userInputs.StateWithholding,
                        WorksheetFederalAgi: userInputs.WorksheetFederalAgi,
                        WorksheetFederalDeductions: userInputs.WorksheetFederalDeductions,
                        WorksheetGeorgiaStandardDeduction: userInputs.WorksheetGeorgiaStandardDeduction,
                        WorksheetAllowableAdjustments: userInputs.WorksheetAllowableAdjustments,
                        WorksheetLine5c: userInputs.WorksheetLine5c,
                        WorksheetLine5e: userInputs.WorksheetLine5e,
                        WorksheetLine5g: userInputs.WorksheetLine5g,
                        WorksheetLine5h: userInputs.WorksheetLine5h,
                        ResidenceState: userInputs.ResidenceState,
                        SpouseResidenceState: userInputs.SpouseResidenceState,
                        ExemptNoLiability: userInputs.ExemptNoLiability,
                        ExemptServicemember: userInputs.ExemptServicemember,
                        Date: userInputs.Date,
                        Signature: userInputs.Signature
                    };
                    if (userInputs != null && userInputs.EmployerNameAddress != null) {
                        ownerData = {
                            EmployerNameAddress: userInputs.EmployerNameAddress,
                            EmployerfederalEIN: userInputs.EmployerfederalEIN,
                            EmployerWithholdingNumber: userInputs.EmployerWithholdingNumber
                        }
                    } else {
                        let gaEmployerNameAddress = '';
                        if (ownerInfo.ShippingAddress) {
                            gaEmployerNameAddress = [ownerInfo.LegalBusinessName || ownerInfo.ClientName, ownerInfo.ShippingAddress.StreetLine1, ownerInfo.ShippingAddress.StreetLine2, ownerInfo.ShippingAddress.AptNum, ownerInfo.ShippingAddress.City, ownerInfo.ShippingAddress.StateName, ownerInfo.ShippingAddress.PostalCode, ownerInfo.ShippingAddress.CountryName].filter(Boolean).join(', ');
                        } else {
                            gaEmployerNameAddress = [ownerInfo.LegalBusinessName || ownerInfo.ClientName].filter(Boolean).join(', ');
                        }
                        const gaSit = stateTaxInfo?.find(x => x.State === String(employeeBankInfo?.StateToBeTaxedIn) && x.Name === 'State Income Tax');
                        ownerData = {
                            EmployerNameAddress: gaEmployerNameAddress,
                            EmployerfederalEIN: ownerInfo.FEIN,
                            EmployerWithholdingNumber: gaSit?.Value ?? ''
                        }
                    }
                    formData = { ...formData, ...ownerData };
                    break;
                case 22:
                    stateCode = 'MD';
                    formData = {
                        RequestTypeId: '2',
                        FullName: userInputs.FullName,
                        EmployeeSocialSecurityNumber: userInputs.EmployeeSocialSecurityNumber,
                        HomeAddress: userInputs.HomeAddress,
                        ResidenceCounty: userInputs.ResidenceCounty,
                        MaritalStatus: userInputs.MaritalStatus,
                        TotalExemptions: userInputs.TotalExemptions,
                        AdditionalWithholding: userInputs.AdditionalWithholding,
                        Exempt: userInputs.Exempt,
                        Exempt2: userInputs.Exempt2,
                        ApplicableYear: userInputs.ApplicableYear,
                        ExemptText1: userInputs.ExemptText1,
                        ExemptText2: userInputs.ExemptText2,
                        ExemptText3: userInputs.ExemptText3,
                        ExemptText4: userInputs.ExemptText4,
                        ExemptText5: userInputs.ExemptText5,
                        ExemptText6: userInputs.ExemptText6,
                        LegalResident: userInputs.LegalResident,
                        Columbia: userInputs.Columbia,
                        Virginia: userInputs.Virginia,
                        WestVirginia: userInputs.WestVirginia,
                        Date: userInputs.Date,
                        Signature: userInputs.Signature
                    };
                    if (userInputs != null && userInputs.EmployerNameAddress != null) {
                        ownerData = {
                            EmployerNameAddress: userInputs.EmployerNameAddress,
                            EmployerfederalEIN: userInputs.EmployerfederalEIN
                        }
                    } else {
                        let mdEmployerNameAddress = '';
                        if (ownerInfo.ShippingAddress) {
                            mdEmployerNameAddress = [ownerInfo.LegalBusinessName || ownerInfo.ClientName, ownerInfo.ShippingAddress.StreetLine1, ownerInfo.ShippingAddress.StreetLine2, ownerInfo.ShippingAddress.AptNum, ownerInfo.ShippingAddress.City, ownerInfo.ShippingAddress.StateName, ownerInfo.ShippingAddress.PostalCode, ownerInfo.ShippingAddress.CountryName].filter(Boolean).join(', ');
                        } else {
                            mdEmployerNameAddress = [ownerInfo.LegalBusinessName || ownerInfo.ClientName].filter(Boolean).join(', ');
                        }
                        ownerData = {
                            EmployerNameAddress: mdEmployerNameAddress,
                            EmployerfederalEIN: ownerInfo.FEIN
                        }
                    }
                    formData = { ...formData, ...ownerData };
                    break;
                default:
                    formData = {
                        RequestTypeId: '2'
                    };
                    state = BoilerPlateW4Modal;
                    break;
            }

            if (state === BoilerPlateW4Modal) {
                //check if !application.IsPaper && employeeBankInfo.StateToBeTaxedIn is not part of  [5, 6, 7, 9, 19, 34, 65, 32] else approve
                if (!application.IsPaperForm && !IMPLEMENTED_PROVINCE_STATE_IDS.includes(employeeBankInfo.StateToBeTaxedIn)) { //IsPaperForm is true when emp has taxable state and submitted a manual paper form but form not yet implemented in apex.
                    return onboardingDocumentService.previewDocument(application.EmployeeId, formData).then(function (result) {
                        const previewUrl = result;
                        return $uibModal.open({
                            ...state,
                            resolve: {
                                title: () => "State W4 Preview: " + employeeBankInfo.StateToBeTaxedIn.Abbr,
                                ownerView: () => true,
                                owner: () => owner,
                                provinces: () => provinces,
                                employeeBankInfo: () => employeeBankInfo,
                                previewUrl: () => {
                                    return previewUrl;
                                },
                                application: () => {
                                    return application;
                                },
                                showPaperWarning: () => {
                                    return true
                                },
                                message: () => {
                                    const taxState = provinces.find(x => x.StateProvinceID === employeeBankInfo.StateToBeTaxedIn);
                                    return `The Tax form for ${taxState.StateName} will be coming in the future. Untill then, please ensure that you are completing the paper form outside of Apex. You will need to ensure that paper copies are kept with your organization for 7 years`;
                                }
                            }
                        }).result;
                    }).then(function (data) {
                        //utilityService.showLoading();
                        console.log(data);
                        if (data === 'ok') {
                            return true;
                        }
                        if (data && data.review) {
                            utilityService.showLoading();
                            const commentPromise = (data.comment && data.comment.trim())
                                ? onboardingDocumentService.saveComment({
                                    ApplicationId: application.ApplicationId,
                                    UserName: owner.UserName,
                                    Text: data.comment,
                                })
                                : $q.resolve();
                            return commentPromise
                                .then(() => onboardingDocumentService.setReviewRequired(employee.EmployeeID, '2'))
                                .then(() => ({ reviewOnly: true }));
                        }
                        return false;
                    }).then(function (approve) {
                        console.log(approve);
                        if (!approve || approve.reviewOnly) {
                            return true;
                        }
                        const approvePromise = onboardingDocumentService.approveOnboardingForm(application.ApplicationId, "2");
                        return $q.all(approvePromise);
                    }).then(function (res) {
                        console.log(res);
                    }).catch(function (reason) {
                        utilityService.hideLoading();
                        console.log("Approval dismissed with reason", reason);
                        alert("Approval Failed:" + reason);
                    }).finally(() => {
                        utilityService.hideLoading();
                        if (source === 'root') {
                            $state.transitionTo('root', null, { reload: true });
                        } else {
                            $state.transitionTo('application-status', null, { reload: true });
                        }
                    });
                } else {
                    const taxState = provinces.find(x => x.StateProvinceID === employeeBankInfo.StateToBeTaxedIn)
                    const res = taxState?.IsStateExemptOnly ? true : confirm(`The Tax form for ${taxState.StateName} will be coming in the future. Untill then, please ensure that you are completing the paper form outside of Apex. You will need to ensure that paper copies are kept with your organization for 7 years`);
                    if (!res) {
                        return;
                    }
                    //run this if prev cond is false
                    return onboardingDocumentService.approveOnboardingForm(application.ApplicationId, "2").then((res) => {
                        console.log(res)
                    }).catch(function (reason) {
                        console.log("Approval dismissed with reason", reason);
                        alert("Approval Failed:" + reason);
                    }).finally(() => {
                        utilityService.hideLoading();
                        if (source === 'root') {
                            $state.transitionTo('root', null, { reload: true });
                        } else {
                            $state.transitionTo('application-status', null, { reload: true });
                        }
                    });
                }
            } else {
                console.log(stateCode);
                return onboardingDocumentService.previewUrl(employee.UserName, formData, employeeBankInfo.StateToBeTaxedIn).then(function (result) {
                    const previewUrl = result;
                    return $uibModal.open({
                        ...state,
                        resolve: {
                            title: () => "State W4 Preview: " + employeeBankInfo.StateToBeTaxedIn.Abbr,
                            previewUrl: () => {
                                return previewUrl;
                            },
                            allowApprove: () => {
                                return canApproveForm(application, '2');
                            },
                            allowReview: () => {
                                return canApproveForm(application, '2');
                            },
                            allowSign: () => {
                                return false;
                            }, //for pages without signature
                            previewByPassed: () => {
                                return true;
                            }
                        }
                    }).result.then(function (data) {
                        utilityService.showLoading();
                        console.log(data);
                        if (data === 'ok') {
                            const promiseArray = [];
                            const submitApplicationPromise = onboardingDocumentService.submit(employee.UserName, formData, employeeBankInfo.StateToBeTaxedIn);
                            promiseArray.push(submitApplicationPromise);
                            return $q.all(promiseArray);
                        }
                        if (data && data.review) {
                            utilityService.showLoading();
                            const commentPromise = (data.comment && data.comment.trim())
                                ? onboardingDocumentService.saveComment({
                                    ApplicationId: application.ApplicationId,
                                    UserName: owner.UserName,
                                    Text: data.comment,
                                })
                                : $q.resolve();
                            return commentPromise
                                .then(() => onboardingDocumentService.setReviewRequired(employee.EmployeeID, '2'))
                                .then(() => ({ reviewOnly: true }));
                        }
                        return false;
                    }).then(function (approve) {
                        console.log(approve);
                        if (!approve || approve.reviewOnly) {
                            return true;
                        }
                        const approvePromise = onboardingDocumentService.approveOnboardingForm(application.ApplicationId, "2");
                        return $q.all(approvePromise);
                    }).then(function (res) {
                        console.log(res);
                    }).catch(function (reason) {
                        console.log("Approval dismissed with reason", reason);
                        alert("Approval Failed:" + reason);
                    }).finally(() => {
                        utilityService.hideLoading();
                        if (source === 'root') {
                            $state.transitionTo('root', null, { reload: true });
                        } else {
                            $state.transitionTo('application-status', null, { reload: true });
                        }
                    });
                })
            }
        }]
    }
}, {
    state: "application-status.i9",
    config: {
        url: "/i9",
        component: "apexI9Modal",
        params: {
            applicationId: { value: null }
        },
        resolve: {
            ownerView: () => {
                return false;
            },
            //applicationId: ['$stateParams', function ($stateParams) {
            //    return $stateParams.applicationId;
            //}],
            employee: (employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveIdentity();
            },
            employeeId: (employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveIdentity().then(function (emp) {
                    return emp.EmployeeID;
                });
            },
            employeeProfile: (employeeId, employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveOnboardingEmployee(employeeId);
            },
            profile: (employeeId, employeeService: EmployeeService) => {
                'ngInject'
                return employeeService.retrieveEmployeeProfile(employeeId);
            },
            employeeBankInfo: (employeeId, employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveEmployeeBankInfo(employeeId); //.then((data) => { return data });
            },
            provinces: (stateProvinceService: StateProvinceService) => {
                'ngInject';
                return stateProvinceService.retrieveStateProvinces();
            },
            application: (employee, onboardingDocumentService: OnboardingDocumentService) => {
                'ngInject';
                // Use methods from onboardingDocumentService here
                return onboardingDocumentService.reterieveApplication(employee.EmployeeID);
            },
            genderOptions: (employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveGenders();
            },
            userInputs: (employee, onboardingDocumentService: OnboardingDocumentService) => {
                'ngInject';
                return onboardingDocumentService.retrieveUserInput(employee.EmployeeID, "3", "0")
            },
            savedInputs: (employee, onboardingDocumentService: OnboardingDocumentService) => {
                'ngInject';
                return onboardingDocumentService.retrieveSavedInput(employee.EmployeeID, "3", "0")
            },
            maritalStatus: (employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveMaritalStatuses();
            },
            addlInputs: (onboardingDocumentService, employee) => {
                'ngInject';
                return onboardingDocumentService.retrieveAddlInputs(employee.EmployeeID);
            }
        },
        onEnter: ['$uibModal', '$state', '$transitions', 'ownerView', 'employee', 'employeeProfile', 'profile', 'employeeBankInfo', 'provinces', 'application', 'genderOptions', 'userInputs', 'savedInputs', 'maritalStatus', 'addlInputs',
            function ($uibModal, $state, $transitions, ownerView, employee, employeeProfile, profile, employeeBankInfo, provinces, application, genderOptions, userInputs, savedInputs, maritalStatus, addlInputs) {
                'ngInject'
                let source = 'application-status';
                $transitions.onSuccess({}, function (transition) {
                    source = transition.from().name
                    console.log(
                        "Successful Transition from " + transition.from().name +
                        " to " + transition.to().name
                    );
                });
                $uibModal.open({
                    ...I9Modal,
                    resolve: {
                        ownerView: () => ownerView,
                        employee: () => employee,
                        employeeProfile: () => employeeProfile,
                        profile: () => profile,
                        employeeBankInfo: () => employeeBankInfo,
                        provinces: () => provinces,
                        application: () => application,
                        genderOptions: () => genderOptions,
                        userInputs: () => userInputs,
                        savedInputs: () => savedInputs,
                        maritalStatus: () => maritalStatus,
                        addlInputs: () => addlInputs
                    }
                }).result.then(function (result) {
                    console.log("Modal closed with result", result);
                }).catch(function (reason) {
                    console.log("Modal dismissed with reason", reason);
                }).finally(() => {
                    if (source === 'root') {
                        $state.transitionTo('root', null, { reload: true });
                    } else {
                        $state.transitionTo('application-status', null, { reload: true });
                    }
                });
            }]
    }
}, {
    state: "application-status.owner-i9",
    config: {
        url: "/owner/i9/:applicationId",
        component: "apexI9Modal",
        params: {
            applicationId: { value: null }
        },
        resolve: {
            ownerView: () => {
                return true;
            },
            applicationId: ['$stateParams', function ($stateParams) {
                return $stateParams.applicationId;
            }],
            application: (applicationId, onboardingDocumentService: OnboardingDocumentService) => {
                'ngInject';
                // Use methods from onboardingDocumentService here
                return onboardingDocumentService.retrieveApplicationById(applicationId);
            },
            employee: (application, employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveEmployeeIdentity(application.EmployeeId);
            },
            owner: (employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveIdentity();
            },
            employeeId: (application) => {
                'ngInject';
                return application.EmployeeId;
            },
            employeeProfile: (employeeId, employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveOnboardingEmployee(employeeId);
            },
            profile: (employeeId, employeeService: EmployeeService) => {
                'ngInject'
                return employeeService.retrieveEmployeeProfile(employeeId);
            },
            employeeBankInfo: (employeeId, employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveEmployeeBankInfo(employeeId); //.then((data) => { return data });
            },
            provinces: (stateProvinceService: StateProvinceService) => {
                'ngInject';
                return stateProvinceService.retrieveStateProvinces();
            },
            genderOptions: (employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveGenders();
            },
            userInputs: (employee, onboardingDocumentService: OnboardingDocumentService) => {
                'ngInject';
                return onboardingDocumentService.retrieveUserInput(employee.EmployeeID, "3", "0")
            },
            maritalStatus: (employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveMaritalStatuses();
            },
            addlInputs: (onboardingDocumentService, employee) => {
                'ngInject';
                return onboardingDocumentService.retrieveAddlInputs(employee.EmployeeID);
            },
            ownerInfo: (employee, icdCorporationService: IcdCorporationService) => {
                'ngInject';
                return icdCorporationService.retrieveIcdCorporation(employee.IcdCorporationID);
            }
        },
        onEnter: ['$uibModal', '$state', '$transitions', 'ownerView', 'employee', 'employeeProfile', 'profile', 'employeeBankInfo', 'provinces', 'application', 'genderOptions', 'userInputs', 'maritalStatus', 'addlInputs', 'owner', 'ownerInfo', function ($uibModal, $state, $transitions, ownerView, employee, employeeProfile, profile, employeeBankInfo, provinces, application, genderOptions, userInputs, maritalStatus, addlInputs, owner, ownerInfo) {
            'ngInject'
            let source = 'application-status';
            $transitions.onSuccess({}, function (transition) {
                source = transition.from().name
                console.log(
                    "Successful Transition from " + transition.from().name +
                    " to " + transition.to().name
                );
            });
            $uibModal.open({
                ...I9Modal,
                resolve: {
                    ownerView: () => ownerView,
                    employee: () => employee,
                    employeeProfile: () => employeeProfile,
                    profile: () => profile,
                    employeeBankInfo: () => employeeBankInfo,
                    provinces: () => provinces,
                    application: () => application,
                    genderOptions: () => genderOptions,
                    userInputs: () => userInputs,
                    maritalStatus: () => maritalStatus,
                    addlInputs: () => addlInputs,
                    owner: () => owner,
                    ownerInfo: () => ownerInfo,
                }
            }).result.then(function (result) {
                console.log("Modal closed with result", result);
            }).catch(function (reason) {
                console.log("Modal dismissed with reason", reason);
            }).finally(() => {
                if (source === 'root') {
                    $state.transitionTo('root', null, { reload: true });
                } else {
                    $state.transitionTo('application-status', null, { reload: true });
                }
            });
        }]
    }
}, {
    state: "application-status.dd",
    config: {
        url: "/direct-deposit",
        component: "apexDDModal",
        params: {
            applicationId: { value: null }
        },
        resolve: {
            ownerView: () => {
                return false;
            },
            //applicationId: ['$stateParams', function ($stateParams) {
            //    return $stateParams.applicationId;
            //}],
            employee: (employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveIdentity();
            },
            employeeId: (employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveIdentity().then(function (emp) {
                    return emp.EmployeeID;
                });
            },
            employeeProfile: (employeeId, employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveOnboardingEmployee(employeeId);
            },
            profile: (employeeId, employeeService: EmployeeService) => {
                'ngInject'
                return employeeService.retrieveEmployeeProfile(employeeId);
            },
            employeeBankInfo: (employeeId, employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveEmployeeBankInfo(employeeId); //.then((data) => { return data });
            },
            provinces: (stateProvinceService: StateProvinceService) => {
                'ngInject';
                return stateProvinceService.retrieveStateProvinces();
            },
            application: (employee, onboardingDocumentService: OnboardingDocumentService) => {
                'ngInject';
                // Use methods from onboardingDocumentService here
                return onboardingDocumentService.reterieveApplication(employee.EmployeeID);
            },
            genderOptions: (employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveGenders();
            },
            savedInfo: (employee, onboardingDocumentService: OnboardingDocumentService) => {
                'ngInject';
                return onboardingDocumentService.getSavedBankInfo(employee.EmployeeID);
            },
            bankInfo: (employee, onboardingDocumentService: OnboardingDocumentService) => {
                'ngInject';
                return onboardingDocumentService.getBankInfo(employee.EmployeeID);
            },
            accountTypes: (onboardingDocumentService: OnboardingDocumentService) => {
                'ngInject';
                return onboardingDocumentService.getBankAccountTypes();
            },
            depositTypes: (onboardingDocumentService: OnboardingDocumentService) => {
                'ngInject';
                return onboardingDocumentService.getBankDepositTypes();
            }
        },
        onEnter: ['$uibModal', '$state', '$transitions', 'ownerView', 'employee', 'employeeProfile', 'profile', 'employeeBankInfo', 'provinces', 'application', 'genderOptions', 'bankInfo', 'savedInfo', 'accountTypes', 'depositTypes',
            function ($uibModal, $state, $transitions, ownerView, employee, employeeProfile, profile, employeeBankInfo, provinces, application, genderOptions, bankInfo, savedInfo, accountTypes, depositTypes) {
                'ngInject'
                let source = 'application-status';
                $transitions.onSuccess({}, function (transition) {
                    source = transition.from().name
                    console.log(
                        "Successful Transition from " + transition.from().name +
                        " to " + transition.to().name
                    );
                });
                $uibModal.open({
                    ...DDModal,
                    resolve: {
                        ownerView: () => ownerView,
                        employee: () => employee,
                        employeeProfile: () => employeeProfile,
                        profile: () => profile,
                        employeeBankInfo: () => employeeBankInfo,
                        provinces: () => provinces,
                        application: () => application,
                        genderOptions: () => genderOptions,
                        bankInfo: () => bankInfo,
                        savedInfo: () => savedInfo,
                        accountTypes: () => accountTypes,
                        depositTypes: () => depositTypes
                    }
                }).result.then(function (result) {
                    console.log("Modal closed with result", result);
                }, function (reason) {
                    console.log("Modal dismissed with result", reason);
                }).catch(function (reason) {
                    console.log("Modal dismissed 2 with reason", reason);
                }).finally(() => {
                    if (source === 'root') {
                        $state.transitionTo('root', null, { reload: true });
                    } else {
                        $state.transitionTo('application-status', null, { reload: true });
                    }
                });
            }]
    }
}, {
    state: "application-status.owner-dd",
    config: {
        url: "/owner/direct-deposit/:applicationId",
        component: "apexDDModal",
        params: {
            applicationId: { value: null }
        },
        resolve: {
            ownerView: () => {
                return true;
            },
            applicationId: ['$stateParams', function ($stateParams) {
                return $stateParams.applicationId;
            }],
            application: (applicationId, onboardingDocumentService: OnboardingDocumentService) => {
                'ngInject';
                // Use methods from onboardingDocumentService here
                return onboardingDocumentService.retrieveApplicationById(applicationId);
            },
            employee: (application, employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveEmployeeIdentity(application.EmployeeId);
            },
            owner: (employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveIdentity();
            },
            employeeId: (application) => {
                'ngInject';
                return application.EmployeeId;
            },
            employeeProfile: (employeeId, employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveOnboardingEmployee(employeeId);
            },
            profile: (employeeId, employeeService: EmployeeService) => {
                'ngInject'
                return employeeService.retrieveEmployeeProfile(employeeId);
            },
            employeeBankInfo: (employeeId, employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveEmployeeBankInfo(employeeId); //.then((data) => { return data });
            },
            provinces: (stateProvinceService: StateProvinceService) => {
                'ngInject';
                return stateProvinceService.retrieveStateProvinces();
            },
            genderOptions: (employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveGenders();
            },
            bankInfo: (employee, onboardingDocumentService: OnboardingDocumentService) => {
                'ngInject';
                return onboardingDocumentService.getBankInfo(employee.EmployeeID);
            },
            accountTypes: (onboardingDocumentService: OnboardingDocumentService) => {
                'ngInject';
                return onboardingDocumentService.getBankAccountTypes();
            },
            depositTypes: (onboardingDocumentService: OnboardingDocumentService) => {
                'ngInject';
                return onboardingDocumentService.getBankDepositTypes();
            }
        },
        onEnter: ['$uibModal', '$state', '$transitions', 'ownerView', 'employee', 'employeeProfile', 'profile', 'employeeBankInfo', 'provinces', 'application', 'genderOptions', 'bankInfo', 'accountTypes', 'depositTypes', 'owner',
            function ($uibModal, $state, $transitions, ownerView, employee, employeeProfile, profile, employeeBankInfo, provinces, application, genderOptions, bankInfo, accountTypes, depositTypes, owner) {
                'ngInject'
                let source = 'application-status';
                $transitions.onSuccess({}, function (transition) {
                    source = transition.from().name
                    console.log(
                        "Successful Transition from " + transition.from().name +
                        " to " + transition.to().name
                    );
                });
                $uibModal.open({
                    ...DDModal,
                    resolve: {
                        ownerView: () => ownerView,
                        employee: () => employee,
                        employeeProfile: () => employeeProfile,
                        profile: () => profile,
                        employeeBankInfo: () => employeeBankInfo,
                        provinces: () => provinces,
                        application: () => application,
                        genderOptions: () => genderOptions,
                        bankInfo: () => bankInfo,
                        accountTypes: () => accountTypes,
                        depositTypes: () => depositTypes,
                        owner: () => owner
                    }
                }).result.then(function (result) {
                    console.log("Modal closed with result", result);
                }, function (reason) {
                    console.log("Modal dismissed with result", reason);
                }).catch(function (reason) {
                    console.log("Modal dismissed 2 with reason", reason);
                }).finally(() => {
                    if (source === 'root') {
                        $state.transitionTo('root', null, { reload: true });
                    } else {
                        $state.transitionTo('application-status', null, { reload: true });
                    }
                });
            }]
    }
}, {
    state: "application-status.confirmation",
    config: {
        url: "/confirmation",
        component: "apexConfirmationModal",
        params: {
            applicationId: { value: null }
        },
        resolve: {
            ownerView: () => {
                return false;
            },
            //applicationId: ['$stateParams', function ($stateParams) {
            //    return $stateParams.applicationId;
            //}],
            employee: (employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveIdentity();
            },
            employeeId: (employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveIdentity().then(function (emp) {
                    return emp.EmployeeID;
                });
            },
            employeeProfile: (employeeId, employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveOnboardingEmployee(employeeId);
            },
            profile: (employeeId, employeeService: EmployeeService) => {
                'ngInject'
                return employeeService.retrieveEmployeeProfile(employeeId);
            },
            employeeBankInfo: (employeeId, employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveEmployeeBankInfo(employeeId); //.then((data) => { return data });
            },
            provinces: (stateProvinceService: StateProvinceService) => {
                'ngInject';
                return stateProvinceService.retrieveStateProvinces();
            },
            application: (employee, onboardingDocumentService: OnboardingDocumentService) => {
                'ngInject';
                // Use methods from onboardingDocumentService here
                return onboardingDocumentService.reterieveApplication(employee.EmployeeID);
            },
            genderOptions: (employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveGenders();
            }
        },
        onEnter: ['$uibModal', '$state', '$transitions', 'ownerView', 'employee', 'employeeProfile', 'profile', 'employeeBankInfo', 'provinces', 'application', 'genderOptions', 'utilityService',
            function ($uibModal, $state, $transitions, ownerView, employee, employeeProfile, profile, employeeBankInfo, provinces, application, genderOptions, utilityService) {
                'ngInject'
                let source = 'application-status';
                $transitions.onSuccess({}, function (transition) {
                    source = transition.from().name
                    console.log(
                        "Successful Transition from " + transition.from().name +
                        " to " + transition.to().name
                    );
                });
                $uibModal.open({
                    ...ConfirmationModal,
                    resolve: {
                        ownerView: () => ownerView,
                        employee: () => employee,
                        employeeProfile: () => employeeProfile,
                        profile: () => profile,
                        employeeBankInfo: () => employeeBankInfo,
                        provinces: () => provinces,
                        application: () => application,
                        genderOptions: () => genderOptions
                    }
                }).result.then(function (result) {
                    console.log("Modal closed with result", result);
                }).catch(function (reason) {
                    console.log("Modal dismissed with reason", reason);
                }).finally(() => {
                    utilityService.hideLoading();
                    if (source === 'root') {
                        $state.transitionTo('root', null, { reload: true });
                    } else {
                        $state.transitionTo('application-status', null, { reload: true });
                    }
                });
            }]
    }
}, {
    state: "application-status.ownermodal",
    config: {
        url: "/owner-modal/:applicationId/:employeeId",
        component: "apexOwnerModal",
        data: {
            pageHeader: "Employer View",
            permissionKey: "navigation:applicationStatus"
        },
        params: {
            applicationId: { value: null },
            employeeId: { value: null }
        },
        redirectTo: 'application-status.ownermodal.userProfile',
        resolve: {
            //modalTitle: function () { return "Owner View" },
            applicationId: ['$stateParams', function ($stateParams) {
                return $stateParams.applicationId;
            }],
            employeeId: ['$stateParams', function ($stateParams) {
                return $stateParams.employeeId;
            }],
            modalTitle: function () {
                return "Employer View: User Profile"
            },
            owner: (employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveIdentity();
            },
            employee: (employeeId, employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveEmployeeIdentity(employeeId);
            },
            employeeProfile: (employeeId, employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveOnboardingEmployee(employeeId);
            },
            profile: (employeeId, employeeService: EmployeeService) => {
                'ngInject'
                return employeeService.retrieveEmployeeProfile(employeeId);
            },
            employeeBankInfo: (employeeId, employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveEmployeeBankInfo(employeeId); //.then((data) => { return data });
            },
            provinceRequired: (employeeId, employeeService, onboardingDocumentService) => {
                'ngInject';
                return employeeService.retrieveEmployeeBankInfo(employeeId).then((data) => {
                    return onboardingDocumentService.checkIfProvinceW4Required(data.StateToBeTaxedIn);
                });
            },
            provinces: (stateProvinceService: StateProvinceService) => {
                'ngInject';
                return stateProvinceService.retrieveStateProvinces();
            },
            application: (employeeId, onboardingDocumentService: OnboardingDocumentService) => {
                'ngInject';
                // Use methods from onboardingDocumentService here
                return onboardingDocumentService.reterieveApplication(employeeId);
            },
            genderOptions: (employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveGenders();
            },
            maritalStatus: (employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveMaritalStatuses();
            },
            fw4UserInputs: (employeeId, onboardingDocumentService: OnboardingDocumentService) => {
                'ngInject';
                return onboardingDocumentService.retrieveUserInput(employeeId, "5", "-1");
            },
            i9UserInputs: (employeeId, onboardingDocumentService: OnboardingDocumentService) => {
                'ngInject';
                return onboardingDocumentService.retrieveUserInput(employeeId, "3", "0");
            },
            ddInputs: (employee, onboardingDocumentService: OnboardingDocumentService) => {
                'ngInject';
                return onboardingDocumentService.getBankInfo(employee.EmployeeID)
            },
            addlInputs: (onboardingDocumentService, employee) => {
                'ngInject';
                return onboardingDocumentService.retrieveAddlInputs(employee.EmployeeID);
            },
            accountTypes: (onboardingDocumentService: OnboardingDocumentService) => {
                'ngInject';
                return onboardingDocumentService.getBankAccountTypes();
            },
            depositTypes: (onboardingDocumentService: OnboardingDocumentService) => {
                'ngInject';
                return onboardingDocumentService.getBankDepositTypes();
            },
            modalInstance: ['$uibModal', 'applicationId', 'employeeId', 'modalTitle', 'owner', 'employee', 'employeeProfile', 'profile', 'employeeBankInfo', 'provinceRequired', 'provinces', 'application', 'genderOptions', 'fw4UserInputs', 'i9UserInputs', 'ddInputs', 'addlInputs', 'accountTypes', 'depositTypes', function ($uibModal, applicationId, employeeId, modalTitle, owner, employee, employeeProfile, profile, employeeBankInfo, provinceRequired, provinces, application, genderOptions, fw4UserInputs, i9UserInputs, ddInputs, addlInputs, accountTypes, depositTypes) {
                return $uibModal.open({
                    ...ApexOwnerModal,
                    resolve: {
                        modalTitle: function () {
                            return modalTitle;
                        },
                        employeeId: function () {
                            return employeeId;
                        },
                        applicationId: function () {
                            return applicationId;
                        },
                        ownerView: function () {
                            return true;
                        },
                        owner: function () {
                            return owner;
                        },
                        employee: function () {
                            return employee;
                        },
                        employeeProfile: function () {
                            return employeeProfile;
                        },
                        profile: function () {
                            return profile;
                        },
                        employeeBankInfo: function () {
                            return employeeBankInfo;
                        },
                        provinceRequired: function () {
                            return provinceRequired;
                        },
                        provinces: function () {
                            return provinces;
                        },
                        application: function () {
                            return application;
                        },
                        genderOptions: function () {
                            return genderOptions;
                        },
                        fw4UserInputs: function () {
                            return fw4UserInputs;
                        },
                        i9UserInputs: function () {
                            return i9UserInputs;
                        },
                        ddInputs: function () {
                            return ddInputs;
                        },
                        maritalStatus: (employeeService: EmployeeService) => {
                            'ngInject';
                            return employeeService.retrieveMaritalStatuses();
                        },
                        addlInputs: function () {
                            return addlInputs;
                        },
                        accountTypes: function () {
                            return accountTypes;
                        },
                        depositTypes: function () {
                            return depositTypes;
                        },
                    }
                });
            }]
        },
        onEnter: ['utilityService', function (utilityService) {
            return utilityService.showLoading();
        }],
        onExit: ['modalInstance', function (modalInstance) {
            return modalInstance.close();
        }]
    }
}, {
    state: "application-status.ownermodal.userProfile",
    config: {
        url: '/user-profile',
        onEnter: ['$rootScope', '$state', function ($rootScope, $state) {
            console.log($state);
            $rootScope.$broadcast('childStateChanged', { newState: 'application-status.ownermodal.userProfile', title: 'Employer View: User Profile' });
        }]
    }
}, {
    state: "application-status.ownermodal.federalW4",
    config: {
        url: '/federal-w4',
        onEnter: ['$rootScope', function ($rootScope) {
            $rootScope.$broadcast('childStateChanged', { newState: 'application-status.ownermodal.federalW4', title: 'Employer View: Federal W4' });
        }]
    }
}, {
    state: "application-status.ownermodal.provinceW4",
    config: {
        url: '/state-w4',
        params: {
            source: { value: 1 }
        },
        resolve: {
            source: ['$stateParams', function ($stateParams) {
                return $stateParams.source;
            }]
        },
        onEnter: ['employeeId', 'provinceRequired', 'employeeBankInfo', 'source', '$state', '$rootScope', function (employeeId, provinceRequired, employeeBankInfo, source, $state, $rootScope) {
            if (!provinceRequired) {
                if (source === 1) {
                    $state.go("application-status.ownermodal.i9");
                } else if (source === 2) {
                    $state.go("application-status.ownermodal.federalW4");
                }
            } else {
                $rootScope.$broadcast('childStateChanged', { newState: 'application-status.ownermodal.provinceW4', title: 'Employer View:State W4' });
                $state.go("application-status.ownermodal.provinceW4-v2",
                    { setstate: employeeBankInfo?.StateAbbrevation });
                //testing for AR
                //$state.go("application-status.ownermodal.provinceW4-v2", { setstate: stateParam });
            }
        }]
    }
}, {
    state: "application-status.ownermodal.provinceW4-v2",
    config: {
        url: '/state-w4/:setstate',
        params: {
            setstate: { value: 'def' }
        },
        onEnter: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
            $rootScope.$broadcast('childStateChanged', { newState: 'application-status.ownermodal.provinceW4-' + $stateParams.setstate, title: 'Employer View:State W4', state: $stateParams.setstate });
            //$rootScope.$broadcast('setState', { state: $stateParams.setstate });

        }]
    }
}, {
    state: "application-status.ownermodal.i9",
    config: {
        url: '/i9',
        onEnter: ['$rootScope', function ($rootScope) {
            $rootScope.$broadcast('childStateChanged', { newState: 'application-status.ownermodal.i9', title: 'Employer View:I9' });
        }]
    }
}, {
    state: "application-status.ownermodal.directdeposit",
    config: {
        url: '/dd',
        onEnter: ['$rootScope', function ($rootScope) {
            $rootScope.$broadcast('childStateChanged', { newState: 'application-status.ownermodal.directdeposit', title: 'Employer View: Direct Deposit' });
        }]
    }
}, {
    state: "application-status.ownermodal.bank-account",
    config: {
        url: '/bank-account',
        onEnter: ['$rootScope', function ($rootScope) {
            $rootScope.$broadcast('childStateChanged', { newState: 'application-status.ownermodal.bank-account', title: 'Employer View: Bank Account' });
        }]
    }
}, {
    state: "application-status.ownermodal.confirmation",
    config: {
        url: '/confirmation',
        onEnter: ['$rootScope', function ($rootScope) {
            $rootScope.$broadcast('childStateChanged', { newState: 'application-status.ownermodal.confirmation', title: 'Employer View: Confirmation' });
        }]
    }
},
{
    state: "onboarding-document",
    config: {
        component: "apexOnboardingDocumentW4Form",
        url: "/onboarding-document",
        data: {
            pageHeader: "Onboarding",
            permissionKey: "navigation:onboardingdocument"
        },
        abstract: true,
        resolve: {
            employee: (employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveIdentity();
            },
            employeeProfile: (employee, employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveOnboardingEmployee(employee.EmployeeID);
            },

            provinces: (stateProvinceService: StateProvinceService) => {
                'ngInject';
                return stateProvinceService.retrieveStateProvinces();
            },
            application: (employee, onboardingDocumentService: OnboardingDocumentService) => {
                'ngInject';
                // Use methods from onboardingDocumentService here
                return onboardingDocumentService.reterieveApplication(employee.EmployeeID);
            },
            genderOptions: (employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveGenders();
            },
            maritalStatus: (employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveMaritalStatuses();
            },
            addlInputs: (onboardingDocumentService, employee) => {
                'ngInject';
                return onboardingDocumentService.retrieveAddlInputs(employee.EmployeeID);
            }
            //setAddlInputs: (onboardingDocumentService: OnboardingDocumentService, employee, fieldName, value) => {
            //    'ngInject';
            //    //return onboardingDocumentService.setAddlInput(employee.EmployeeID, fieldName, value);
            //    // Define a function to set additional input
            //    function setAddlInputEvent(employeeId, fieldName, value) {
            //        // Call the service method and return its result
            //        return onboardingDocumentService.setAddlInput(employeeId, fieldName, value);
            //    }

            //    // Return the function as an event
            //    return {
            //        setAddlInputEvent: setAddlInputEvent
            //    };
            //}
        }
    }
},
{
    state: "onboarding-document.userProfile",
    config: {
        url: "",
        component: "apexUserProfile",
        data: {
            pageHeader: "Onboarding",
            permissionKey: "navigation:onboardingdocument"
        },
        resolve: {
            employeeProfile: (employee, employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveOnboardingEmployee(employee.EmployeeID);
            },
            profile: (employee, employeeService: EmployeeService) => {
                'ngInject'
                return employeeService.retrieveEmployeeProfile(employee.EmployeeID);
            },
            employeeBankInfo: (employee, employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveEmployeeBankInfo(employee.EmployeeID);
            },
            ownerView: () => {
                return false;
            }
        }
    }
},
{
    state: "onboarding-document.federalW4",
    config: {
        url: "/federalW4",
        component: "apexFederalW4",
        data: {
            pageHeader: "Onboarding",
            permissionKey: "navigation:onboardingdocument"
        },
        resolve: {
            userInputs: (employee, onboardingDocumentService: OnboardingDocumentService) => {
                'ngInject';
                return onboardingDocumentService.retrieveUserInput(employee.EmployeeID, "5", "-1")
            },
            maritalStatus: (employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveMaritalStatuses();
            },
            employeeProfile: (employee, employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveOnboardingEmployee(employee.EmployeeID);
            },
            profile: (employee, employeeService: EmployeeService) => {
                'ngInject'
                return employeeService.retrieveEmployeeProfile(employee.EmployeeID);
            },
            employeeBankInfo: (employee, employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveEmployeeBankInfo(employee.EmployeeID);
            },
            ownerView: () => {
                return false;
            }
            //signModal: ($state) => {
            //    'ngInject';
            //    return ["$event", params => {
            //        $state.go(".signature-pad", params)
            //    }]
            //}
        }
    }
},
{
    state: "onboarding-document.provinceW4",
    config: {
        url: "/stateW4",
        template: "<ui-view></ui-view>",
        params: {
            stateID: { value: null },
            source: { value: 1 }
        },
        //abstract: true,
        data: {
            pageHeader: "Onboarding",
            permissionKey: "navigation:onboardingdocument"
        },
        resolve: {
            source: ['$stateParams', function ($stateParams) {
                return $stateParams.source;
            }],
            implStates: () => {
                const stringArray = ["AR", "AL", "AZ", "NY", "KY", "CA", "TX", "FL"];
                return stringArray;
            },
            provinceRequired: (employeeBankInfo, $state, source, $stateParams, onboardingDocumentService: OnboardingDocumentService) => {
                'ngInject';
                if ($stateParams.stateID != null) {
                    return;
                }
                return onboardingDocumentService.checkIfProvinceW4Required(employeeBankInfo.StateToBeTaxedIn).then((req) => {
                    if (!req) {
                        if (source === 1) {
                            $state.go("onboarding-document.i9");
                        }
                        if (source === 2) {
                            $state.go("onboarding-document.federalW4");
                        }
                    }
                })
            },
            employeeProfile: (employee, employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveOnboardingEmployee(employee.EmployeeID);
            },
            profile: (employee, employeeService: EmployeeService) => {
                'ngInject'
                return employeeService.retrieveEmployeeProfile(employee.EmployeeID);
            },
            employeeBankInfo: (employee, employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveEmployeeBankInfo(employee.EmployeeID);
            },
            redirectState: (employeeBankInfo, $stateParams, implStates) => {
                'ngInject';
                // Determine which component to load based on a variable or condition
                //return "onboarding-document.provinceW4.AR"
                //testing for other states
                if ($stateParams.stateID != null) {
                    return "onboarding-document.provinceW4." + $stateParams.stateID;
                } else if (!implStates.includes(employeeBankInfo.StateAbbrevation)) {
                    return "onboarding-document.provinceW4.boilerplate";
                } else {
                    return "onboarding-document.provinceW4." + employeeBankInfo.StateAbbrevation;
                }
            },
            ownerView: () => {
                return false;
            }
        },
        controller: ['$scope', '$state', 'redirectState', function ($scope, $state, redirectState) {
            // Use the selectedChild parameter to navigate to the chosen child state
            $state.go(redirectState);
        }],
    }
},
{
    state: "onboarding-document.i9",
    config: {
        url: "/i9",
        component: "apexI9",
        data: {
            pageHeader: "Onboarding",
            permissionKey: "navigation:onboardingdocument"
        },
        resolve: {
            userInputs: (employee, onboardingDocumentService: OnboardingDocumentService) => {
                'ngInject';
                return onboardingDocumentService.retrieveUserInput(employee.EmployeeID, "3", "0")
            },
            employeeProfile: (employee, employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveOnboardingEmployee(employee.EmployeeID);
            },
            profile: (employee, employeeService: EmployeeService) => {
                'ngInject'
                return employeeService.retrieveEmployeeProfile(employee.EmployeeID);
            },
            employeeBankInfo: (employee, employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveEmployeeBankInfo(employee.EmployeeID);
            },
            ownerView: () => {
                return false;
            }
        }
    }
},
{
    state: "onboarding-document.directdeposit",
    config: {
        url: "/direct-deposit",
        component: "apexDirectDeposit",
        data: {
            pageHeader: "Onboarding",
            permissionKey: "navigation:onboardingdocument"
        },
        resolve: {
            ownerView: () => false,
            profile: (employee, employeeService: EmployeeService) => {
                'ngInject'
                return employeeService.retrieveEmployeeProfile(employee.EmployeeID);
            },
            employeeBankInfo: (employee, employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveEmployeeBankInfo(employee.EmployeeID);
            },
            bankInfo: (employee, onboardingDocumentService: OnboardingDocumentService) => {
                'ngInject';
                return onboardingDocumentService.getBankInfo(employee.EmployeeID);
            },
            accountTypes: (onboardingDocumentService: OnboardingDocumentService) => {
                'ngInject';
                return onboardingDocumentService.getBankAccountTypes();
            },
            depositTypes: (onboardingDocumentService: OnboardingDocumentService) => {
                'ngInject';
                return onboardingDocumentService.getBankDepositTypes();
            }
        }
    }
},
{
    state: "onboarding-document.bank-account",
    config: {
        url: "/bank-account",
        component: "apexAddBankAccount",
        data: {
            pageHeader: "Onboarding",
            permissionKey: "navigation:onboardingdocument"
        },
        resolve: {
        }
    }
},
{
    state: "onboarding-document.confirmation",
    config: {
        url: "/confirmation",
        component: "apexConfirmationForm",
        data: {
            pageHeader: "Onboarding",
            permissionKey: "navigation:onboardingdocument"
        },
        resolve: {

        }
    }
},
{
    state: "onboarding-document.provinceW4.boilerplate",
    config: {
        url: "/temp",
        component: "apexStateBoilerPlate",
        data: {
            pageHeader: "Onboarding",
            permissionKey: "navigation:onboardingdocument"
        },
        resolve: {
            ownerView: () => {
                return false;
            }
            //userInputs: (employee, onboardingDocumentService: OnboardingDocumentService) => {
            //    'ngInject';
            //    return onboardingDocumentService.retrieveUserInput(employee.EmployeeID, "2", "6");
            //}
        }
    }
},
{
    state: "onboarding-document.provinceW4.AR",
    config: {
        url: "/AR",
        component: "apexArW4",
        data: {
            pageHeader: "Onboarding",
            permissionKey: "navigation:onboardingdocument"
        },
        resolve: {
            //userInputs: (employee, onboardingDocumentService: OnboardingDocumentService) => {
            //    'ngInject';
            //    return onboardingDocumentService.retrieveUserInput(employee.EmployeeID, "2", "6");
            //}
        }
    }
},
{
    state: "onboarding-document.provinceW4.KY",
    config: {
        url: "/KY",
        component: "apexKyW4",
        data: {
            pageHeader: "Onboarding",
            permissionKey: "navigation:onboardingdocument"
        },
        resolve: {

        }
    }
},
{
    state: "onboarding-document.provinceW4.NY",
    config: {
        url: "/NY",
        component: "apexNyW4",
        data: {
            pageHeader: "Onboarding",
            permissionKey: "navigation:onboardingdocument"
        },
        resolve: {

        }
    }
},
{
    state: "onboarding-document.provinceW4.AL",
    config: {
        url: "/AL",
        component: "apexAlW4",
        data: {
            pageHeader: "Onboarding",
            permissionKey: "navigation:onboardingdocument"
        },
        resolve: {

        }
    }
},
{
    state: "onboarding-document.provinceW4.AZ",
    config: {
        url: "/AZ",
        component: "apexAzW4",
        data: {
            pageHeader: "Onboarding",
            permissionKey: "navigation:onboardingdocument"
        },
        resolve: {

        }
    }
},
{
    state: "onboarding-document.provinceW4.CO",
    config: {
        url: "/CO",
        component: "apexCoW4",
        data: {
            pageHeader: "Onboarding",
            permissionKey: "navigation:onboardingdocument"
        },
        resolve: {

        }
    }
}
]

export const OnboardingDocumentRoutingModule = angular
    .module("apex.mainApp.onboaring-document.routing", [])
    .run(configureStates(states))
    .name;
